import React from 'react';
import multiTenantTabs from './multi-tenant-tables/index';
import PropertyInformation from './tabs-components/PropertyInformation';
import CurrentRR from './tabs-components/CurrentRR';
import CurrentReimbursement from './tabs-components/CurrentReimbursement';
import Pricing from './tabs-components/Pricing';
import Expenses from './tabs-components/Expenses';
import Marketing from './tabs-components/Marketing';
import {buildGeneralInformationRow} from './multi-tenant-tables/current-rr-tab/general-information';
import {buildDetailedInformationRow} from './multi-tenant-tables/current-rr-tab/detailed-information';
import {buildDetailedInformationRowReimbursement} from './multi-tenant-tables/current-reimbursement-tab/detailed-information';
import {buildRentRollRow} from './multi-tenant-tables/marketing-tab/rent-roll';
import {buildReimbursementsRow} from "./multi-tenant-tables/marketing-tab/reimbursements";
import {buildReimbursementTypes, buildReimbursableOpEx} from './multi-tenant-tables/current-reimbursement-tab/annex';
import request from "arcdynamic-request";
import unitedStates from 'united-states';
import {
    dateProps,
    numberProps,
    stringProps,
    checkboxProps,
    tenantFields,
    tenantTypeFields,
    defaultValues,
    pricingChanges
} from './mt-fields-to-save';
import BaseTabComponent from "./tabs-components/BaseTabComponent";
import {stringISOtoUS, stringUStoISO} from '../../date-converter';
import PrintMultiTenant from "../PrintMultiTenant";
import PrintBOV from "../PrintBOV";
import {getTemplate, bovOfficeFor} from "../PrintBOV/bov-templates";
import {addCommasToNumber, findTenantRow, isSeniorAgent} from "../../utils";
import {UNDERWRITING_MULTI_TENANT, UNDERWRITING_PARCELS, UNDERWRITING_EXPENSES_CAMS, UNDERWRITING_TENANT_TYPES,  TENANTS, PROPOSAL} from '../../consts/tables';
import {UNDERWRITING_TENANT_LIST} from '../../consts/queries';
import {executeQuery} from "../../requests/executeQuery";
import filter from "../../filter";
import {defaultReimbursementTypesNo, taxAssessmentsNo, reimbursementTypesNo, camDefaultRowNo, computeReimbTypes} from "./utils";
import {buildSummedRentRoll} from "./multi-tenant-tables/marketing-tab/sumed-rent-roll";
import {buildSummedReimbursements} from "./multi-tenant-tables/marketing-tab/sumed-reimbursements";
import { ApolloConsumer } from '@apollo/client';
import { CREATE_UPDATE_UNDERWRITING_PARCELS, GET_PROPERTY_UNDERWRITING_TENANTS, GET_UNDERWRITING_EXPENSES_CAM, GET_UNDERWRITING_MULTI_TENANT_WITH_PROPERTYID, GET_UNDERWRITING_PARCELS, GET_UNDERWRITING_TENENT_TYPE } from '../Graphql/Queries/propertiesQuery';
import { CREATE_TENANTS } from '../Graphql/Mutations/TenantMutation';
import { CREATE_TENANTS_IN_MULTITENANT, UNDERWRITING_TENANTS, UPDATE_UNDERWRITING_EXPENSES_CAMS, UPDATE_UNDERWRITING_MULTI_TENANT, UPDATE_UNDERWRITING_TENENT_TYPES } from '../Graphql/Mutations/propertiesMutation';
import { fetchData, mutateData } from '../Service/graphQlService';
import { getData } from '../../requests/CRUD';
import PopupDialog from '../PopupDialog';
import { GET_PRICING_ANALYSIS_BY_PRODUCT_TYPE } from '../Graphql/Queries/ProposalQuery';


const cloneDeep = require('lodash.clonedeep');
const findIndex = require('lodash.findindex');
const find = require('lodash.find');

function preProcess(items){
    return items.map((val)=>(val.link.split('?')[0]))
}
const defualtStaticImages = [
    '5e0c4d6dce9179486afe80a6477eff1dc58162e4b98f229a6803f502ffa805f1e81aed03eed324daeaaf10e93a7465738358eb56a56445fe4d536345f9a7d7f1_Multi_Tenant_image_2.jpg',
    'd58b316b34600cd5b8e9e87d9dbd163fa1b5076618560fade22ac6894d20b7bfd8721e0476f67f93587f18dc89b275ea5f51a1548d971b272d08a579121ea822_Multi_Tenant_image_3.jpg',
    '049d13b291386df926097985dc53dc023dd70de7260c6e9ddd467ef42621a2db782344522adfb273463c71ec10413475f386a9af78b72f3f42db171d5ad92e3f_Multi_Tenant_image_4.jpg',
    '70f7dac2885221da236fffd73dd1c93c05270e056443f2f1525f8ccb021ff317ca7495c7945aa0e5358c904f1199ee3e73a8acf3b83121c288d59f3845c6a75d_Multi_Tenant_image_5.jpg',
    'ddc9908769f6caa303d66bb823f677bd534811083a03098c3ca995e2ec1892905ff9102976592deb8b0caa87bc53410a9f019f856bca78c72dacba235a718e9f_Multi_Tenant_image_6.jpg',
    'f49b363cdde33c4d97e2d0b6b6b496445113d42f4986c7ac08f79af7c54939f90e4fe65091209b30be80b27867e5fb38ff616ff26ebdd8e740d99a3756bf048d_Multi_Tenant_image_7.jpg',
    '85126a8b64d985427432ff35d2ae06944b148531688f2cdd78c4a8e5868d96bc9d2dd009209dff20508bcc979c1d5c46c21b133b0dfd6cdae63534163e3f58a7_Multi_Tenant_image_8.jpg',
    '51c4e133099e07ad2b3a8403232800f37b6e34c5def27d68b2d52636491e723e2a82867987933f3b180bc81f69e5f4a8d6a1456f6cf91d4eb2299b44f419017b_Multi_Tenant_image_9.jpg',
]

export default class UnderwritingMultiTenant extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                tabs: multiTenantTabs,
            },
            original: {
                tabs: multiTenantTabs,
            },
            selectedTab: 'marketing-tab',
            newData: null,
            parcelsData: null,
            camData: null,
            tenantsData: null,
            tenantTypeData: null,
            sqFtUpdated: false,
            camPSFSumUpdated: false,
            mgmtUpdated: false,
            insuranceUpdated: false,
            taxesUpdated: false,
            dataLoaded: false,
            isProformaVisible: false,
            isProformaVisiblePricing: false,
            isAdditionalPriceVisible: false,
            isMarketingAdditionalPriceVisible: false,
            displayPopupSubmit: false,
            sortState: 'default',
            movedRows: false,
            reimbTypesManuallyModified: false,
            originalReimbTypesManuallyModified: false,
            staticImages:[],
            isBusy: false,
            isDialogueOpen: false,
            dialogTitle:'',
            dataReloadCounter: 0,  // Add counter to force re-render on data reload
        };
        this.client = null;
        this.getUnderwritingData = this.getUnderwritingData.bind(this);
        this.tabValueChange = this.tabValueChange.bind(this);
        this.tabValuesChange = this.tabValuesChange.bind(this);
        this.addRow = this.addRow.bind(this);
        this.deleteRowCurrentRR = this.deleteRowCurrentRR.bind(this);
        this.deleteRowCAM = this.deleteRowCAM.bind(this);
        this.moveRow = this.moveRow.bind(this);
        this.moveCorrespondingRows = this.moveCorrespondingRows.bind(this);
        this.reassignTenantRowIds = this.reassignTenantRowIds.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.findTenant = this.findTenant.bind(this);
        this.splitAtLastSpace = this.splitAtLastSpace.bind(this);
        this.saveTenant = this.saveTenant.bind(this);
        this.handleExpand = this.handleExpand.bind(this);
        this.handleExpandShow = this.handleExpandShow.bind(this);
        this.togglePopupMessage = this.togglePopupMessage.bind(this);
        this.setState = this.setState.bind(this);
        this.sortTenants = this.sortTenants.bind(this);
        this.getStaticImages = this.getStaticImages.bind(this);
        this.onConfirm = this.onConfirm.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.beforeSubmit = this.beforeSubmit.bind(this);
    }

    async componentDidMount() {
        await this.getUnderwritingData();
        // Computing heavily-used values at the start of the render.
        const precomputedValues = BaseTabComponent.precomputeHeavilyUsedValues(this.state.data.tabs);
        const state = UnderwritingMultiTenant.setDefaultValues(this.state.data, precomputedValues);
        this.setState(state);
        let type = this.props.data.category === 'apartments'? 'apartments' : this.props.data.category+'-MT';
        if(((this.props.data.multi_tenant_subcategory && this.props.data.multi_tenant_subcategory.toLowerCase().includes("vacant")) || (this.props.data.lease_type && this.props.data.lease_type.toLowerCase().includes("vacant")))){
            type = type+'-vacant';
        }
        this.getStaticImages(type);
    }

    static findCamRowNO(rows) {
        let lastCamRowIndex = -1, camNo = 0;
        rows.map((row, index) => {
            if (/(cam-[0-9])/g.test(row[0])) {
                lastCamRowIndex = index;
                camNo++;
            }
        });
        return {lastCamRowIndex, camNo};
    }

    setForceStatic(newData, prop) {
        if (prop.hasOwnProperty('valueCellIndex')) {
            newData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].forceStatic = !prop.hasOwnProperty('forceStatic');
        } else {
            newData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].forceStatic = !prop.hasOwnProperty('forceStatic');
        }
    }

    setFieldsDisabled(data) {
        const newData = cloneDeep(data);

        stringProps.map(prop => {
            this.setForceStatic(newData, prop);
        });
        dateProps.map(prop => {
            this.setForceStatic(newData, prop);
        });
        numberProps.map(prop => {
            this.setForceStatic(newData, prop);
        });

        for (let index = 0; index < taxAssessmentsNo; index++) {
            newData.tabs['property-information-tab'].tables['parcel'].rows[`tax-assessment-${index+1}`].valueCells.map(cell => {
                cell.forceStatic = true;
            });
        }

        const camRows = newData.tabs['expenses-tab'].tables['expenses'].rows;
        const cams = Object.entries(camRows);
        let {camNo} = UnderwritingMultiTenant.findCamRowNO(cams);
        for (let index = 0; index < camNo; index++) {
            camRows[`cam-${index+1}`].valueCells.map(cell => {
                if (cell.editable) {
                    cell.forceStatic = true;
                }
            });
        }

        const tenantNo = Object.keys(newData.tabs['current-rr-tab'].tables['general-information'].rows).length;
        tenantFields.map(prop => {
            for (let index = 0; index < tenantNo; index++) {
                newData.tabs[prop.tab].tables[prop.table].rows[index].valueCells[prop.valueCellIndex].forceStatic = true;
            }
        });

        const reimbursementTypes = newData.tabs['current-reimbursement-tab'].tables['reimbursement-types'].rows;
        for (let index = 0; index < reimbursementTypesNo; index++) {
            const row = reimbursementTypes[index];
            row.valueCells.map((cell, index) => {
                if (![0, 8, 10].includes(index)) {
                    cell.forceStatic = true;
                }
            });
        }

        return newData;
    }

    async getUnderwritingData(isSaved) {
        let data = cloneDeep(this.state.data);
        const propsData = this.props.data;

        // Set the dropdown values
        data.tabs['property-information-tab'].tables['general-information'].rows['state'].dropdownValues = unitedStates;

        if (!this.props.data.arcimedes_row_id) {
            await this.initTenants(data, [{}], false);
            return;
        }

        await this.getTenants(data);
        //const token = localStorage.getItem('authToken')
        const res = await Promise.all([
            // request(arc.path.api, {
            //     service: 'arcimedes',
            //     action: 'open.datasource.table.Data.getData',
            //     params: ['code', UNDERWRITING_MULTI_TENANT, {
            //         filter: [{
            //             'text': this.props.data.ARCIMEDES_ROW_ID,
            //             'code': 'PROPERTY_ID',
            //             'type': 'exact',
            //         }],
            //     }],
            // }),
            // this.client.query({ query: GET_UNDERWRITING_MULTI_TENANT_WITH_PROPERTYID, variables: { propertyId: this.props.data.arcimedes_row_id },
            //     fetchPolicy: "no-cache",
            //     context: {
            //       headers: {
            //         authorization: `Bearer ${token}`,
            //       },
            //     } }),
            fetchData(GET_UNDERWRITING_MULTI_TENANT_WITH_PROPERTYID, { propertyId: this.props.data.arcimedes_row_id }),
            // request(arc.path.api, {
            //     service: 'arcimedes',
            //     action: 'open.datasource.table.Data.getData',
            //     params: ['code', UNDERWRITING_PARCELS, {
            //         filter: [{
            //             'text': this.props.data.ARCIMEDES_ROW_ID,
            //             'code': 'PROPERTY_ID',
            //             'type': 'exact',
            //         }],
            //         order: [{
            //             code: 'PARCEL',
            //             type: 'asc',
            //         }]
            //     }],
            // }),
            // this.client.query({ query: GET_UNDERWRITING_PARCELS, variables: { propertyId: this.props.data.arcimedes_row_id },
            //     fetchPolicy: "no-cache",
            //     context: {
            //       headers: {
            //         authorization: `Bearer ${token}`,
            //       },
            //     } }),
            fetchData(GET_UNDERWRITING_PARCELS, { propertyId: this.props.data.arcimedes_row_id }),
            // request(arc.path.api, {
            //     service: 'arcimedes',
            //     action: 'open.datasource.table.Data.getData',
            //     params: ['code', UNDERWRITING_EXPENSES_CAMS, {
            //         filter: [{
            //             'text': this.props.data.ARCIMEDES_ROW_ID,
            //             'code': 'PROPERTY_ID',
            //             'type': 'exact',
            //         }, {
            //             'text': '',
            //             'code': 'DELETED',
            //             'type': 'null',
            //         }],
            //         filterType: 'and',
            //         order: [{
            //             code: 'cam_index',
            //             type: 'asc',
            //         }]
            //     }],
            // }),
            // this.client.query({ query: GET_UNDERWRITING_EXPENSES_CAM, variables: { propertyId: this.props.data.arcimedes_row_id },
            //     fetchPolicy: "no-cache",
            //     context: {
            //       headers: {
            //         authorization: `Bearer ${token}`,
            //       },
            //     } }),
            fetchData(GET_UNDERWRITING_EXPENSES_CAM, { propertyId: this.props.data.arcimedes_row_id }),
            // request(arc.path.api, {
            //     service: 'arcimedes',
            //     action: 'open.datasource.table.Data.getData',
            //     params: ['code', UNDERWRITING_TENANT_TYPES, {
            //         filter: [{
            //             'text': this.props.data.ARCIMEDES_ROW_ID,
            //             'code': 'PROPERTY_ID',
            //             'type': 'exact',
            //         }],
            //         order: [{
            //             code: 'REIMB_TYPES_INDEX',
            //             type: 'asc',
            //         }]
            //     }],
            // })
            // this.client.query({ query: GET_UNDERWRITING_TENENT_TYPE, variables: { propertyId: this.props.data.arcimedes_row_id },
            //     fetchPolicy: "no-cache",
            //     context: {
            //       headers: {
            //         authorization: `Bearer ${token}`,
            //       },
            //     } }),
            fetchData(GET_UNDERWRITING_TENENT_TYPE, { propertyId: this.props.data.arcimedes_row_id }),
        ]);

        if (res) {
            const parcels = data.tabs['property-information-tab'].tables['parcel'].rows;
            const tenantTypes = data.tabs['current-reimbursement-tab'].tables['reimbursement-types'];
            const tenantTypesProForma = data.tabs['proforma-reimbursement-tab'].tables['reimbursement-types'];
            const tenantOpEx = data.tabs['current-reimbursement-tab'].tables['reimbursable-op-ex'];
            const tenantOpExProForma = data.tabs['proforma-reimbursement-tab'].tables['reimbursable-op-ex'];
            let parcelsData = null;
            let camData = null;
            let tenantTypeData = null;
            let reimbTypesManuallyModified = false;

            // Manage data from PROPERTIES table
            stringProps.map(prop => {
                // get property props
                if (propsData.hasOwnProperty(prop.key)) {
                    if (prop.hasOwnProperty('valueCellIndex')) {
                        data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value = propsData[prop.key] || '';
                    } else {
                        data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value = propsData[prop.key] || '';
                    }
                }
            });

            dateProps.map(prop => {
                // get property props
                if (propsData.hasOwnProperty(prop.key)) {
                    if (prop.hasOwnProperty('valueCellIndex')) {
                        data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value = propsData[prop.key] ? stringISOtoUS(propsData[prop.key]) : '';
                    } else {
                        data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value = propsData[prop.key] ? stringISOtoUS(propsData[prop.key]) : '';
                    }
                }
            });

            numberProps.map(prop => {
                // get property props
                if (propsData.hasOwnProperty(prop.key)) {
                    let value;
                    if (prop.withReplace && prop.withToFixed) {
                        value = propsData[prop.key] ? parseFloat(propsData[prop.key].replace(/,/g, '')).toFixed(2) : '';
                    } else if (prop.withToFixed) {
                        value = propsData[prop.key] ? parseFloat(propsData[prop.key]).toFixed(2) : '';
                    } else if (prop.withReplace) {
                        value = propsData[prop.key] ? parseFloat(propsData[prop.key].replace(/,/g, '')) : '';
                    } else {
                        value = parseFloat(propsData[prop.key]) || '';
                    }
                    if (prop.hasOwnProperty('valueCellIndex')) {
                        data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value = value;
                    } else {
                        data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value = value;
                    }
                }
            });

            // Manage data from UNDERWRITING_TENANT_TYPES table
            if (res[3] && res[3].data && Array.isArray(res[3].data.getUnderwritingTenentType)) {
                const rawTenantTypes = res && res[3] && res[3].data && Array.isArray(res[3].data.getUnderwritingTenentType)
                    ? res[3].data.getUnderwritingTenentType
                    : [];
                const descriptionOrder = {
                    'NNN': 0,
                    'NNN (Excl MGMT)': 1,
                    'NNN+5%AF (Excl MGMT)': 2,
                    'NNN+10%AF (Excl MGMT)': 3,
                    'NNN+15%AF (Excl MGMT)': 4,
                    'NN': 5,
                    'Gross': 6
                };
                // tenantTypeData = res[3].data.getUnderwritingTenentType.length > 0 ? cloneDeep(res[3].data.getUnderwritingTenentType) : Array(defaultReimbursementTypesNo).fill({});
                tenantTypeData = rawTenantTypes.length > 0
                    ? cloneDeep(rawTenantTypes).sort((a, b) => {
                        const aDesc = a && a.pro_forma_reimb_types_description ? a.pro_forma_reimb_types_description : '';
                        const bDesc = b && b.pro_forma_reimb_types_description ? b.pro_forma_reimb_types_description : '';

                        const aOrder = descriptionOrder.hasOwnProperty(aDesc) ? descriptionOrder[aDesc] : 999;
                        const bOrder = descriptionOrder.hasOwnProperty(bDesc) ? descriptionOrder[bDesc] : 999;

                        return aOrder - bOrder;
                    })
                    : Array(defaultReimbursementTypesNo).fill({});
                tenantOpEx.rows = buildReimbursableOpEx('current-reimbursement-tab');
                tenantOpExProForma.rows = buildReimbursableOpEx('proforma-reimbursement-tab');

                tenantTypes.rows = Object.assign({}, (new Array(reimbursementTypesNo)).fill(null).map((row, index) => {
                    const typesDataRow = tenantTypeData[index] ? tenantTypeData[index] : {};
                    return buildReimbursementTypes(typesDataRow, index, 'current-reimbursement-tab');
                }));
                tenantTypesProForma.rows = Object.assign({}, (new Array(reimbursementTypesNo)).fill(null).map((row, index) => {
                    const typesDataRow = tenantTypeData[index] ? tenantTypeData[index] : {};
                    return buildReimbursementTypes(typesDataRow, index, 'proforma-reimbursement-tab');
                }));
            }

            // Manage data from UNDERWRITING_EXPENSES_CAMS table
            if (res[2] && res[2].data && Array.isArray(res[2].data.getUnderwritingExpensesCam)) {
                camData = this.reindexCamIndex(cloneDeep(res[2].data.getUnderwritingExpensesCam));
                const rows = Object.entries(data.tabs['expenses-tab'].tables['expenses'].rows);
                let {camNo} = UnderwritingMultiTenant.findCamRowNO(rows);

                camData.map(row => {
                    if (camData.length > camNo) {
                        const dataWithRows = this.addRow(['expenses-tab', 'current-reimbursement-tab'], [['expenses'], ['reimbursable-op-ex']], 'cam-1', true, true);
                        data.tabs['expenses-tab'].tables['expenses'].rows = dataWithRows.tabs['expenses-tab'].tables['expenses'].rows;
                        data.tabs['current-reimbursement-tab'].tables['reimbursable-op-ex'].rows = dataWithRows.tabs['current-reimbursement-tab'].tables['reimbursable-op-ex'].rows;
                        camNo = camNo + camDefaultRowNo;
                    }
                    if(data.tabs['expenses-tab'].tables['expenses'].rows[`cam-${row.cam_index}`]){
                        data.tabs['expenses-tab'].tables['expenses'].rows[`cam-${row.cam_index}`].valueCells[0].value = row.cam_name || '';
                        data.tabs['expenses-tab'].tables['expenses'].rows[`cam-${row.cam_index}`].valueCells[2].value = row.cam_value ? parseFloat(row.cam_value).toFixed(2) : '';
                        data.tabs['expenses-tab'].tables['expenses'].rows[`cam-${row.cam_index}`].valueCells[5].value = row.proforma_cam_value ? parseFloat(row.proforma_cam_value).toFixed(2) : '';
                        data.tabs['expenses-tab'].tables['expenses'].rows[`cam-${row.cam_index}`].valueCells[7].value = row.arcimedes_row_id;
                    }
                });
            }
            // Manage data from UNDERWRITING_MULTI_TENANT table
            if (res[0] && res[0].data && Array.isArray(res[0].data.getUnderwritingMultiTenent)) {
                const result = res[0].data.getUnderwritingMultiTenent ? res[0].data.getUnderwritingMultiTenent[0] : {};
                stringProps.map(prop => {
                    // get underwriting data
                    if (result && result.hasOwnProperty(prop.key)) {
                        if (prop.hasOwnProperty('valueCellIndex')) {
                            data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value = result[prop.key] || '';
                        } else {
                            data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value = result[prop.key] || '';
                        }
                    }
                });

                dateProps.map(prop => {
                    // get underwriting data
                    if (result && result.hasOwnProperty(prop.key)) {
                        if (prop.hasOwnProperty('valueCellIndex')) {
                            data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value = result[prop.key] ? stringISOtoUS(result[prop.key]) : '';
                        } else {
                            data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value = result[prop.key] ? stringISOtoUS(result[prop.key]) : '';
                        }
                    }
                });

                numberProps.map(prop => {
                    // get underwriting data
                    if (result && result.hasOwnProperty(prop.key)) {
                        if (prop.hasOwnProperty('valueCellIndex')) {
                            if (prop.withReplace && prop.withToFixed) {
                                data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value = result[prop.key] ? parseFloat(result[prop.key].replace(/,/g, '')).toFixed(2) : '';
                                return;
                            }
                            if (prop.withToFixed) {
                                data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value = result[prop.key] ? parseFloat(result[prop.key]).toFixed(2) : '';
                                return;
                            }
                            data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value = parseFloat(result[prop.key]) || '';
                        } else {
                            data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value = parseFloat(result[prop.key]) || '';
                        }
                    }
                });

                checkboxProps.map(prop => {
                    // get underwriting data
                    if (result && result.hasOwnProperty(prop.key)) {
                        if (prop.hasOwnProperty('valueCellIndex'))
                            data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value = result[prop.key] === null ? '' : !!parseInt(result[prop.key]);
                        else
                            data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value = result[prop.key] === null ? '' : !!parseInt(result[prop.key]);
                    }
                });

                const isProformaPricing = data.tabs['pricing-tab'].tables['pricing-analysis'].rows['proforma-checkbox'].valueCells[1].value;
                const isAssumableLoan = data.tabs['pricing-tab'].tables['pricing-analysis'].rows['assumable-loan-checkbox'].valueCells[1].value;
                data.tabs = UnderwritingMultiTenant.changePricingView(data.tabs, isProformaPricing, isAssumableLoan, this.state.tenantsData);
                reimbTypesManuallyModified = result && !!result.reimb_types_manually_modified;
            }

            // Manage data from UNDERWRITING_PARCELS table
            if (res[1] && res[1].data && Array.isArray(res[1].data.getUnderwritingParcel)) {
                parcelsData = cloneDeep(res[1].data.getUnderwritingParcel);
                //NEW CODE
                parcelsData.map((row, index) => {
                    const taxAssessmentKey = `tax-assessment-${index + 1}`;
                    if (parcels[taxAssessmentKey]) { // Check if the key exists in parcels
                        parcels[taxAssessmentKey].valueCells[0].value = row.parcel || '';
                        parcels[taxAssessmentKey].valueCells[1].value = parseFloat(row.assessed_value) || '';
                        parcels[taxAssessmentKey].valueCells[2].value = parseFloat(row.tax_liability) || '';
                    }
                });
                //OLD CODE

                // parcelsData.map((row, index) => {
                //     if(index <= 3){
                //     parcels[`tax-assessment-${index + 1}`].valueCells[0].value = row.parcel || '';
                //     parcels[`tax-assessment-${index + 1}`].valueCells[1].value = parseFloat(row.assessed_value) || '';
                //     parcels[`tax-assessment-${index + 1}`].valueCells[2].value = parseFloat(row.tax_liability) || '';
                //     }
                // });
            }

            this.setState({
                data,
                original: cloneDeep(data),
                parcelsData,
                camData,
                tenantTypeData,
                reimbTypesManuallyModified,
                originalReimbTypesManuallyModified: reimbTypesManuallyModified,
                // Set flags to true when reloading data so components recalculate
                // They will be set back to false by computeReimbTypes
                sqFtUpdated: isSaved ? true : false,
                camPSFSumUpdated: isSaved ? true : false,
                mgmtUpdated: isSaved ? true : false,
                insuranceUpdated: isSaved ? true : false,
                taxesUpdated: isSaved ? true : false,
                // Increment counter to force component re-render
                dataReloadCounter: isSaved ? this.state.dataReloadCounter + 1 : this.state.dataReloadCounter,
            }, () => {
                if (isSaved) this.props.parentSetData({success: 'Saved'});
            });
        }
    }

    async getTenants(data, key, sort, sortState) {
        const query = {
            PROPERTY_ID: this.props.data.arcimedes_row_id,
        };
        if (key && sort) query.order = `${key}.${sort}`;
        else query.order = 'TENANT_ROW_ID.asc';
        const options = filter(query, 'underwritingMT');
        //const res = await executeQuery({queryName: UNDERWRITING_TENANT_LIST, options});
        
        let foundTenants = [{}];
        let isProformaPricingView = false;
    //     const token = localStorage.getItem('authToken')
    //    await this.client.query({ query: GET_PROPERTY_UNDERWRITING_TENANTS, variables: { propertyId: this.props.data.arcimedes_row_id },
    //         fetchPolicy: "no-cache",
    //         context: {
    //           headers: {
    //             authorization: `Bearer ${token}`,
    //           },
    //         } })
        await fetchData(GET_PROPERTY_UNDERWRITING_TENANTS, { propertyId: this.props.data.arcimedes_row_id })
            .then(res => {
        //if (res && res.success && Array.isArray(res.data.getUnderwritingTenent) && res.data.getUnderwritingTenent.length) {
        if (res && Array.isArray(res.data.getUnderwritingTenent) && res.data.getUnderwritingTenent.length) {

            const tenantsData = res.data.getUnderwritingTenent;
            isProformaPricingView = res.data.getUnderwritingTenent[0].proforma_checkbox === null ? '' : !!parseInt(res.data.getUnderwritingTenent[0].proforma_checkbox);

            tenantsData.map((row, index) => {
                tenantFields.map(prop => {
                    if (!foundTenants[index]) {
                        foundTenants[index] = {};
                    }
                    switch (prop.type) {
                        case 'string': {
                            foundTenants[index][prop.key] = row[prop.key] || '';
                            break;
                        }
                        case 'number': {
                            let value;
                            if (prop.withReplace && prop.withToFixed) {
                                value = row[prop.key] ? parseFloat(row[prop.key].replace(/,/g, '')).toFixed(2) : '';
                            } else if (prop.withToFixed) {
                                value = row[prop.key] ? parseFloat(row[prop.key]).toFixed(2) : '';
                            } else if (prop.withReplace) {
                                value = row[prop.key]
                                ? parseFloat(
                                    (typeof row[prop.key] === 'string' 
                                        ? row[prop.key] 
                                        : String(row[prop.key])
                                    ).replace(/,/g, '')
                                    )
                                : '';
                            } else {
                                value = parseFloat(row[prop.key]) || '';
                            }

                            foundTenants[index][prop.key] = value;
                            break;
                        }
                        case 'date': {
                            foundTenants[index][prop.key] = row[prop.key] ? stringISOtoUS(row[prop.key]) : '';
                            break;
                        }
                    }
                });
            });

            const state = {
                tenantsData: tenantsData,
            };
            if (sortState) state.sortState = sortState;

            this.setState(state);
        }
    })
        if(sortState === "desc"){
            foundTenants.sort((a, b) => {
                return b.rr_suite_code.localeCompare(a.rr_suite_code, undefined, { numeric: true });
            });
        }else if(sortState === "asc"){
            foundTenants.sort((a, b) => {
                return a.rr_suite_code.localeCompare(b.rr_suite_code, undefined, { numeric: true });                
            });
        }  
        
        await this.initTenants(data, foundTenants, isProformaPricingView);
    }

    initTenants(data, tenants, isProformaPricingView) {
        const generalInformation = data.tabs['current-rr-tab'].tables['general-information'];
        const detailedInformation = data.tabs['current-rr-tab'].tables['detailed-information'];
        const generalInformationProForma = data.tabs['proforma-rr-tab'].tables['general-information'];
        const detailedInformationProForma = data.tabs['proforma-rr-tab'].tables['detailed-information'];
        const proformaReimbursementDetailedInformation = data.tabs['proforma-reimbursement-tab'].tables['detailed-information'];
        const currentReimbursementDetailedInformation = data.tabs['current-reimbursement-tab'].tables['detailed-information'];
        const marketingRentRoll = data.tabs['marketing-tab'].tables['rent-roll'];
        const marketingReimbursements = data.tabs['marketing-tab'].tables['reimbursements'];
        const marketingSummedRentRoll = data.tabs['marketing-tab'].tables['sumed-rent-roll'];
        const marketingSummedReimbursements = data.tabs['marketing-tab'].tables['sumed-reimbursements'];

        generalInformation.rows = Object.assign({}, tenants.map((row) => {
            return buildGeneralInformationRow(row, 'current-rr-tab');
        }));
        detailedInformation.rows = Object.assign({}, tenants.map((row) => {
            return buildDetailedInformationRow(row, 'current-rr-tab');
        }));
        generalInformationProForma.rows = Object.assign({}, tenants.map((row) => {
            return buildGeneralInformationRow(row, 'proforma-rr-tab');
        }));
        detailedInformationProForma.rows = Object.assign({}, tenants.map((row) => {
            return buildDetailedInformationRow(row, 'proforma-rr-tab');
        }));
        proformaReimbursementDetailedInformation.rows = Object.assign({}, tenants.map((row) => {
            return buildDetailedInformationRowReimbursement(row, 'proforma-reimbursement-tab');
        }));
        currentReimbursementDetailedInformation.rows = Object.assign({}, tenants.map((row) => {
            return buildDetailedInformationRowReimbursement(row, 'current-reimbursement-tab');
        }));
        marketingRentRoll.rows = Object.assign({}, tenants.map(() => {
            return buildRentRollRow(isProformaPricingView ? 'proforma-rr-tab' : 'current-rr-tab', isProformaPricingView ? 'proforma-reimbursement-tab' : 'current-reimbursement-tab');
        }));
        marketingReimbursements.rows = Object.assign({}, tenants.map(() => {
            return buildReimbursementsRow(isProformaPricingView ? 'proforma-reimbursement-tab' : 'current-reimbursement-tab');
        }));
        marketingSummedRentRoll.rows = buildSummedRentRoll(isProformaPricingView ? 'proforma-rr-tab' : 'current-rr-tab');
        marketingSummedReimbursements.rows = buildSummedReimbursements(isProformaPricingView ? 'proforma-reimbursement-tab' : 'current-reimbursement-tab', isProformaPricingView ? 'proforma-rr-tab' : 'current-rr-tab');

        this.setState({
            data: data,
            original: cloneDeep(data)
        });
    }

//     static setDefaultValue(tabs, field, rowIdentifier, precomputedValues) {
//         const defaultValue = field.getDefaultValue({index: rowIdentifier, tabs, precomputedValues}) || '';
//         const row = tabs[field.tab].tables[field.table].rows[rowIdentifier];
//         if(row && row.valueCells){
//         if (field && field.hasOwnProperty('valueCellIndex')
//             && (row.valueCells[field.valueCellIndex].type === 'boolean' && row.valueCells[field.valueCellIndex].value === ''
//                 || row.valueCells[field.valueCellIndex].type !== 'boolean' && !row.valueCells[field.valueCellIndex].value))
//             row.valueCells[field.valueCellIndex].value = defaultValue;
//         if (!row.value)
//             row.value = defaultValue;
// return tabs;
//     }
// }
static setDefaultValue(tabs, field, rowIdentifier, precomputedValues) {
    if (!tabs || !field || rowIdentifier == null) {
        console.error("Invalid arguments passed to setDefaultValue", { tabs, field, rowIdentifier });
        return tabs;
    }

    const defaultValue = field.getDefaultValue({ index: rowIdentifier, tabs, precomputedValues }) || '';
    const tab = tabs[field.tab];
    if (!tab || !tab.tables || !tab.tables[field.table]) {
        console.error("Invalid tab or table structure in tabs", { field, tabs });
        return tabs;
    }

    const row = tab.tables[field.table].rows[rowIdentifier];
    if (row && row.valueCells) {
        if (field.hasOwnProperty('valueCellIndex') &&
            row.valueCells[field.valueCellIndex] &&
            ((row.valueCells[field.valueCellIndex].type === 'boolean' &&
              row.valueCells[field.valueCellIndex].value === '') ||
             (row.valueCells[field.valueCellIndex].type !== 'boolean' &&
              !row.valueCells[field.valueCellIndex].value))) {
            row.valueCells[field.valueCellIndex].value = defaultValue;
        }

        if (!row.value) {
            row.value = defaultValue;
        }
    } else {
        console.log("Row or valueCells is undefined", { rowIdentifier, field, row });
    }
    return tabs;
}


    static setDefaultValues(resultData, precomputedValues) {
        let data = cloneDeep(resultData);

        defaultValues.map(field => {
            if (field && field.hasOwnProperty('tableKey'))
                data.tabs = UnderwritingMultiTenant.setDefaultValue(data.tabs, field, field.tableKey, precomputedValues);
            else {
                if (field && field.tab === 'proforma-rr-tab') {
                    const tenantRowsNo = Object.keys(data.tabs[field.tab].tables['detailed-information'].rows).length;
                    for (let index = 0; index < tenantRowsNo; index++) {
                        data.tabs = UnderwritingMultiTenant.setDefaultValue(data.tabs, field, index, precomputedValues);
                    }
                }
                if (['current-reimbursement-tab', 'proforma-reimbursement-tab'].includes(field.tab)) {
                    for (let index = 0; index < defaultReimbursementTypesNo; index++) {
                        data.tabs = UnderwritingMultiTenant.setDefaultValue(data.tabs, field, index, precomputedValues);
                    }
                }
            }
        });

        return {
            data: data,
            dataLoaded: true,
        };
    }

    static changePricingView(tabs, isProformaPricing, isAssumableLoan, tenants) {
        pricingChanges.map(prop => {        
            if (prop.hasOwnProperty('valueCellIndex'))
                tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex][prop.property] = prop.getValue(isProformaPricing, isAssumableLoan);
            else
                tabs[prop.tab].tables[prop.table].rows[prop.tableKey][prop.property] = prop.getValue(isProformaPricing, isAssumableLoan);
        });
        if (tenants) {
            tabs['marketing-tab'].tables['rent-roll'].rows = Object.assign({}, tenants.map(() => {
                return buildRentRollRow(isProformaPricing ? 'proforma-rr-tab' : 'current-rr-tab', isProformaPricing ? 'proforma-reimbursement-tab' : 'current-reimbursement-tab');
            }));
            tabs['marketing-tab'].tables['reimbursements'].rows = Object.assign({}, tenants.map(() => {
                return buildReimbursementsRow(isProformaPricing ? 'proforma-reimbursement-tab' : 'current-reimbursement-tab');
            }));
        }
        tabs['marketing-tab'].tables['sumed-rent-roll'].rows = buildSummedRentRoll(isProformaPricing ? 'proforma-rr-tab' : 'current-rr-tab');
        tabs['marketing-tab'].tables['sumed-reimbursements'].rows = buildSummedReimbursements(isProformaPricing ? 'proforma-reimbursement-tab' : 'current-reimbursement-tab', isProformaPricing ? 'proforma-rr-tab' : 'current-rr-tab');
        return tabs;
    }

    togglePopupMessage() {
        this.setState({displayPopupSubmit: !this.state.displayPopupSubmit})
    }

    changeTab(tabKey) {
        const state = cloneDeep(this.state);
        state.selectedTab = tabKey;
        this.setState(state);
    }

    tabValueChange({tab, table, row, value, columnIndex, reimbTypesManuallyModified, assumableLoanPricingViewChange}) {
        const data = cloneDeep(this.state.data);
        // De-alias the target row so an edit only ever affects the selected cell/row.
        // Two rows can share the same object reference (e.g. after a drag/sort or when
        // several rows share a tenant_row_id), and lodash cloneDeep preserves shared
        // references, so without this a write would leak into another row.
        data.tabs[tab].tables[table].rows[row] = cloneDeep(data.tabs[tab].tables[table].rows[row]);
        if (columnIndex === undefined || columnIndex === null) {
            data.tabs[tab].tables[table].rows[row].value = value;
        } else {
            data.tabs[tab].tables[table].rows[row].valueCells[columnIndex].value = value;
            if (columnIndex === 2 && row === "additional-price") {
                data.tabs[tab].tables[table].rows[row].valueCells[6].value = value;
            }
        }

        const isAssumableLoan = data.tabs['pricing-tab'].tables['pricing-analysis'].rows['assumable-loan-checkbox'].valueCells[1].value;
        const isProformaPricing = data.tabs['pricing-tab'].tables['pricing-analysis'].rows['proforma-checkbox'].valueCells[1].value;
        if(assumableLoanPricingViewChange){
            data.tabs = UnderwritingMultiTenant.changePricingView(data.tabs, isProformaPricing, isAssumableLoan, this.state.tenantsData);
        }
        const state = {
            data,
        };
        if (reimbTypesManuallyModified)
            state.reimbTypesManuallyModified = reimbTypesManuallyModified;
        this.setState(state);
    }

    tabValuesChange({tabs, tables, rowIds, values, columnIds, sqFtChanged = null, camChanged = null, mgmtChanged = null, insuranceChanged = null, taxesChanged = null, reimbTypesManuallyModified, proformaPricingViewChange, isProformaPricing}) {
        const data = cloneDeep(this.state.data);
        tabs.forEach((tab, index) => {
            const table = tables[index];
            const rowIndex = rowIds[index];
            const columnIndex = columnIds[index];
            const value = values[index];
            // De-alias the target row so the write only affects this row, not rows that
            // share the same object reference (cloneDeep preserves shared references).
            data.tabs[tab].tables[table].rows[rowIndex] = cloneDeep(data.tabs[tab].tables[table].rows[rowIndex]);
            if (columnIndex === undefined || columnIndex === null) {
                data.tabs[tab].tables[table].rows[rowIndex].value = value;
            } else {
                data.tabs[tab].tables[table].rows[rowIndex].valueCells[columnIndex].value = value;
            }
        });
        const isAssumableLoan = data.tabs['pricing-tab'].tables['pricing-analysis'].rows['assumable-loan-checkbox'].valueCells[1].value;
        if (proformaPricingViewChange)
            data.tabs = UnderwritingMultiTenant.changePricingView(data.tabs, isProformaPricing, isAssumableLoan, this.state.tenantsData);

        const state = {
            data,
        };
        if (reimbTypesManuallyModified)
            state.reimbTypesManuallyModified = reimbTypesManuallyModified;
        if (sqFtChanged !== null)
            state.sqFtUpdated = sqFtChanged;
        if (camChanged !== null)
            state.camPSFSumUpdated = camChanged;
        if (mgmtChanged !== null)
            state.mgmtUpdated = mgmtChanged;
        if (insuranceChanged !== null)
            state.insuranceUpdated = insuranceChanged;
        if (taxesChanged !== null)
            state.taxesUpdated = taxesChanged;
        this.setState(state);
    }

    addRow(tabIdentifiers, tableIdentifiers, rowIdentifier, isCAMRow = false, withReturn = false) {
        let data = cloneDeep(this.state.data);
        let newRowIdentifier = Date.now().toString();

        // generate TABLE_ROW_ID
        let maxIndex = -1;
        if (tabIdentifiers.includes('current-rr-tab')) {
            const rows = data.tabs['current-rr-tab'].tables['general-information'].rows;
            const tableRowIdIndex = rows[0].valueCells.length - 1;  // TENANT_ROW_ID should always be the last column
            Object.keys(rows).forEach(key => {
                const value = parseInt(rows[key].valueCells[tableRowIdIndex].value);
                maxIndex =  value > maxIndex ? value : maxIndex;
            });

            // the keys have to be consecutive because of the drag & drop
            newRowIdentifier = Object.keys(rows).length;
        }

        tabIdentifiers.forEach((tabIdentifier, index) => {
            tableIdentifiers[index].forEach(tableIdentifier => {
                data.tabs[tabIdentifier] = this.addRowToTable(data.tabs, tabIdentifier, tableIdentifier, rowIdentifier, newRowIdentifier, isCAMRow, maxIndex);
            });
        });

        if (withReturn) return data;
        this.setState({data: data});
    }

    addRowToTable(tabs, tabIdentifier, tableIdentifier, rowIdentifier, newRowIdentifier, isCAMRow, maxIndex) {
        let rows = tabs[tabIdentifier].tables[tableIdentifier].rows;
        let auxRow = cloneDeep(rows[rowIdentifier]);
        const tableRowIdIndex = auxRow.valueCells.length - 1;  // TENANT_ROW_ID should always be the last column

        auxRow.valueCells.forEach((cell, index) => {
            if (['current-rr-tab', 'proforma-rr-tab', 'current-reimbursement-tab', 'proforma-reimbursement-tab'].includes(tabIdentifier) &&
                ['general-information', 'detailed-information'].includes(tableIdentifier) &&
                index === tableRowIdIndex) {
                cell.value = (maxIndex + 1).toString();
                return;
            }
            if ((cell.editable || cell.hidden) && cell.hasOwnProperty('value')) {
                cell.value = '';
            }
        });

        rows = Object.entries(rows);

        if (isCAMRow) {
            let {lastCamRowIndex, camNo} = UnderwritingMultiTenant.findCamRowNO(rows);
            const defaultCamRowNo = 5;
            for (let index = 0; index < defaultCamRowNo; index++) {
                lastCamRowIndex++;
                rows.splice(lastCamRowIndex, 0, cloneDeep([`cam-${camNo + 1}`, auxRow]));
                camNo++;
            }
        } else {
            rows.push([newRowIdentifier, auxRow]);
        }

        const rowsObj = {};
        rows.map(item => {
            rowsObj[item[0]] = item[1];
        });

        tabs[tabIdentifier].tables[tableIdentifier].rows = rowsObj;

        return tabs[tabIdentifier];
    }

    deleteRowCurrentRR(rowIdentifier) {
        let data = cloneDeep(this.state.data);

        data.tabs['current-rr-tab'] = this.deleteRowFromTable(data.tabs['current-rr-tab'], 'general-information', rowIdentifier, true);
        data.tabs['current-rr-tab'] = this.deleteRowFromTable(data.tabs['current-rr-tab'], 'detailed-information', rowIdentifier, true);
        data.tabs['proforma-rr-tab'] = this.deleteRowFromTable(data.tabs['proforma-rr-tab'], 'general-information', rowIdentifier, true);
        data.tabs['proforma-rr-tab'] = this.deleteRowFromTable(data.tabs['proforma-rr-tab'], 'detailed-information', rowIdentifier, true);
        data.tabs['current-reimbursement-tab'] = this.deleteRowFromTable(data.tabs['current-reimbursement-tab'], 'detailed-information', rowIdentifier, true);
        data.tabs['proforma-reimbursement-tab'] = this.deleteRowFromTable(data.tabs['proforma-reimbursement-tab'], 'detailed-information', rowIdentifier, true);
        data.tabs['marketing-tab'] = this.deleteRowFromTable(data.tabs['marketing-tab'], 'rent-roll', rowIdentifier, true);
        data.tabs['marketing-tab'] = this.deleteRowFromTable(data.tabs['marketing-tab'], 'reimbursements', rowIdentifier, true);

        this.setState({data});
    }

    deleteRowFromTable(tab, tableIdentifier, rowIdentifier, consecutive) {
        const rowsCount = Object.keys(tab.tables[tableIdentifier].rows).length;
        if (rowsCount <= 1) {
            alert("You can't delete all the rows from the table!");
            return null;
        }

        if (consecutive) {
            // move rows up and delete the last one
            const tenantRowIdIndex = tab.tables[tableIdentifier].rows[rowIdentifier].valueCells.length - 1;
            for (let index = parseInt(rowIdentifier); index < rowsCount - 1; index++) {
                const tenantRowId = tab.tables[tableIdentifier].rows[index].valueCells[tenantRowIdIndex].value;
                tab.tables[tableIdentifier].rows[index] = cloneDeep(tab.tables[tableIdentifier].rows[index + 1]);
                tab.tables[tableIdentifier].rows[index].valueCells[tenantRowIdIndex].value = tenantRowId;
            }
            delete tab.tables[tableIdentifier].rows[rowsCount - 1];
        } else {
            delete tab.tables[tableIdentifier].rows[rowIdentifier];
        }

        return tab;
    }

    deleteRowCAM(tabIdentifiers, tableIdentifiers, rowIdentifier) {
        let data = cloneDeep(this.state.data);

        tabIdentifiers.forEach((tabIdentifier, index) => {
            tableIdentifiers[index].forEach(tableIdentifier => {
                const rows = data.tabs[tabIdentifier].tables[tableIdentifier].rows;
                const rowsAsArray = Object.entries(rows);
                let {camNo} = UnderwritingMultiTenant.findCamRowNO(rowsAsArray);

                if (camNo <= camDefaultRowNo) {
                    alert("You can't delete more rows from the table!");
                    return null;
                } else {
                    let camIndex = parseInt(rowIdentifier.split('-')[1], 10);
                    while (rows[`cam-${camIndex+1}`]) {
                        rows[`cam-${camIndex}`] = rows[`cam-${camIndex+1}`];
                        camIndex++;
                    }
                    delete rows[`cam-${camIndex}`];
                }
            });
        });

        this.setState({data: data});
    }

    moveRow({tabId, tableId, dragIndex, hoverIndex}) {
        const data = cloneDeep(this.state.data);
        const rows = data.tabs[tabId].tables[tableId].rows;
        const dragRow = cloneDeep(rows[dragIndex]);
        rows[dragIndex] = rows[hoverIndex];
        rows[hoverIndex] = dragRow;
        this.setState({
            data,
            movedRows: true,
        });
    }

    moveCorrespondingRows({changedTabId, changedTableId, tabIds, tableIds}) {
        // move all corresponding rows after dnd in Current Rent Roll general-information table & reset sort
        if (this.state.movedRows) {
            const data = cloneDeep(this.state.data);
            const changedRows = data.tabs[changedTabId].tables[changedTableId].rows;
            const valKeyIndex = changedRows[0].valueCells.length - 1;

            tabIds.map((tabId, index) => {
                tableIds[index].map(tableId => {
                    const keys = Object.keys(changedRows);
                    const rows = data.tabs[tabId].tables[tableId].rows;
                    const valueKeyIndex = rows[0].valueCells.length - 1; // TENANT_ROW_ID should always be the last column
                    data.tabs[tabId].tables[tableId].rows = keys.reduce((obj, key) => ({...obj, [key]: cloneDeep(findTenantRow(rows, valueKeyIndex, changedRows[key].valueCells[valKeyIndex].value))}), {});
                });
            });
            this.setState({
                data,
                sortState: 'default',
            });
        }
    }

    // reassignTenantRowIds() {
    //     const data = cloneDeep(this.state.data);
    //     const rows = data.tabs['current-rr-tab'].tables['general-information'].rows;
    //     const tenantRowId = rows[0].valueCells.length - 1; // TENANT_ROW_ID should always be the last column
    //     const ids = [];

    //     Object.keys(rows).forEach(key => {
    //         ids.push(rows[key].valueCells[tenantRowId].value);
    //     });
    //     ids.sort();

    //     Object.keys(rows).map((key, index) => {
    //         rows[key].valueCells[tenantRowId].value = ids[index];
    //     });

    //     this.setState({
    //         data,
    //         movedRows: false,
    //     }, () => this.onSubmit());
    // }
reassignTenantRowIds() {
    const data = cloneDeep(this.state.data);

    // After a drag in the Current Rent Roll, moveRow re-orders general-information and
    // moveCorrespondingRows re-orders every related table (current/proforma RR
    // detailed-information and the reimbursement tables) so they all share the same row
    // order. Persisted order is driven by TENANT_ROW_ID (rows load with
    // ORDER BY TENANT_ROW_ID.asc), and the save logic groups each tenant's fields into a
    // single record keyed by the TENANT_ROW_ID of the table the field lives in.
    // Therefore TENANT_ROW_ID must be reassigned by position in EVERY one of those
    // tables: reassigning only general-information leaves detailed-information on its old
    // ids, so detail fields (Start/End dates, rents, ...) get written onto a different
    // tenant's record — i.e. dragging a row appears to change its data.
    const tablesToReassign = [
        {tab: 'current-rr-tab', table: 'general-information'},
        {tab: 'current-rr-tab', table: 'detailed-information'},
        {tab: 'proforma-rr-tab', table: 'general-information'},
        {tab: 'proforma-rr-tab', table: 'detailed-information'},
        {tab: 'current-reimbursement-tab', table: 'detailed-information'},
        {tab: 'proforma-reimbursement-tab', table: 'detailed-information'},
    ];

    tablesToReassign.forEach(({tab, table}) => {
        const tableData = data.tabs[tab] && data.tabs[tab].tables[table];
        const rows = tableData && tableData.rows;
        if (!rows || !rows[0]) return;
        const tenantRowIdIndex = rows[0].valueCells.length - 1; // TENANT_ROW_ID is always the last column

        // Reassign based on current row order (array index). All these tables are kept in
        // the same order by moveCorrespondingRows, so position i is the same tenant in
        // every table and gets the same id everywhere.
        Object.keys(rows).forEach((key, index) => {
            rows[key].valueCells[tenantRowIdIndex].value = index;
        });
    });

    this.setState({
        data,
        movedRows: false,
    }, () => this.onSubmit());
}

    findTenant(tenantName) {
        const tenants = this.props.allTenantsById;
        return find(tenants, {name: tenantName}) || null;
    }
    splitAtLastSpace(str) {
        const index = str.lastIndexOf(" ");
        if (index === -1) return [str, ""]; // no space found
        return [str.slice(0, index), str.slice(index)];
      };
      
    async saveTenant(tenantName) {
        // const res = await request(arc.path.api, {
        //     service: 'arcimedes',
        //     action: 'open.datasource.table.Data.updateByTableCode',
        //     params: [TENANTS, {
        //         value: [{NAME: tenantName}],
        //     }],
        // });
        const token = localStorage.getItem('authToken');
    //   const res = await this.client.mutate({
    //     mutation: CREATE_TENANTS,
    //     variables: {
    //       name: tenantName
    //     },
    //     fetchPolicy: "no-cache",
    //     context: {
    //       headers: {
    //         authorization: `Bearer ${token}`,
    //       },
    //     },
    //   });

    const [firstPart, secondPart] = this.splitAtLastSpace(tenantName);

    //   const res = await mutateData(CREATE_TENANTS, {name: tenantName })
    //     if (res && res.data && res.data.createOrUpdateTenent && res.data.createOrUpdateTenent.tenent) {
    //         return res.data.createOrUpdateTenent.tenent;
    //     }
    // }

    const input = {
        "first_name": firstPart.trim(),
        "last_name": secondPart.trim(),
        "name": tenantName,
        "contact_type": "Tenant"
    };
      const res = await mutateData(CREATE_TENANTS_IN_MULTITENANT, {input:input})
            if (res && res.data && res.data.createOrUpdateContact && res.data.createOrUpdateContact.contact) {
                return res.data.createOrUpdateContact.contact;
            }
        }
    async onSubmit() {
        const {parcelsData, camData, tenantsData, tenantTypeData} = this.state;
        let data = this.state.data;
        const originalData = this.state.original;
        const propsData = cloneDeep(this.props.data);
        const propertyId = this.props.data.arcimedes_row_id;
        const underwritingData = {};
let changesInPropData = false;

        const precomputedValues = BaseTabComponent.precomputeHeavilyUsedValues(this.state.data.tabs);
        // Compute Reimbursement Types values
        ['current-reimbursement-tab', 'proforma-reimbursement-tab'].forEach(tab => {
            const state = computeReimbTypes({
                result: data.tabs,
                tab: tab,
                precomputedValues,
                newSqft: this.state.sqFtUpdated,
                newCam: this.state.camPSFSumUpdated,
                newMgmt: this.state.mgmtUpdated,
                newInsurance: this.state.insuranceUpdated,
                newTaxes: this.state.taxesUpdated,
                reimbTypesManuallyModified: this.state.reimbTypesManuallyModified,
            });
            data = state.data;
        });
        stringProps.map(prop => {
            let value, originalValue;
            if (prop.hasOwnProperty('valueCellIndex')) {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
            } else {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
            }

            if (prop.fromProps) {
                // set property props
                if (value !== originalValue) {
                    propsData[prop.key] = value;
                    changesInPropData = true;
                }
            } else {
                // set underwritingData just if the value has been changed
                if (value !== originalValue) {
                    underwritingData[prop.key] = value;
                }
            }
        });

        dateProps.map(prop => {
            let value, originalValue;
            if (prop.hasOwnProperty('valueCellIndex')) {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
            } else {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
            }

            if (prop.fromProps) {
                // set property props
                if (value !== originalValue) {
                    propsData[prop.key] = value;
                    changesInPropData = true;
                }
            } else {
                // set underwritingData just if the value has been changed
                if (value !== originalValue) {
                    underwritingData[prop.key] = value ? stringUStoISO(value) : '';
                }
            }
        });

        numberProps.map(prop => {
            let value, originalValue;
            if (prop.hasOwnProperty('valueCellIndex')) {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
            } else {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
            }

            if (prop.fromProps) {
                // set property props
                if (prop.withReplace) {
                    if (value !== originalValue) {
                        propsData[prop.key] = addCommasToNumber(value);
                        changesInPropData = true;
                    }
                    return;
                }
                if (value !== originalValue) {
                    propsData[prop.key] = value.toString();
                    changesInPropData = true;
                }
            } else {
                if (value !== originalValue) {
                    underwritingData[prop.key] = parseFloat(value);
                }
            }
        });

        checkboxProps.map(prop => {
            let value, originalValue;
            if (prop.hasOwnProperty('valueCellIndex')) {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
            } else {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
            }

            // set underwritingData just if the value has been changed
            if (value !== originalValue)
                underwritingData[prop.key] = value ? 1 : 0;

        });

        const noi = data.tabs['pricing-tab'].tables['net-operating-income'].rows['net-operating-income'].valueCells[2].getComputedValue(data.tabs, precomputedValues).internalValue;
        const proformaNoi = data.tabs['pricing-tab'].tables['net-operating-income'].rows['net-operating-income'].valueCells[6].getComputedValue(data.tabs, precomputedValues).internalValue;
        const proformaCapRate = data.tabs['pricing-tab'].tables['value'].rows['cap-rate'].valueCells[6].value;
        const proformaBaseRent = data.tabs['pricing-tab'].tables['base-rent'].footerRow.valueCells[6].getComputedValue(data.tabs, precomputedValues).internalValue;
        

        if (noi > 0) {
            propsData.net_operating_income = addCommasToNumber(noi);
        }
        // Proforma property financials changes
        if (proformaNoi > 0) {
            propsData.proforma_noi = proformaNoi;
        }
        if(proformaBaseRent > 0){
            propsData.proforma_base_rent = proformaBaseRent;
        }
        if(proformaCapRate > 0){
            propsData.proforma_cap_rate = proformaCapRate;
        }


        const listPrice = data.tabs['pricing-tab'].tables['value'].rows['value'].valueCells[2].getComputedValue(data.tabs, precomputedValues).internalValue;
        if (listPrice > 0) {
            propsData.list_price = addCommasToNumber(listPrice);
        }
        const baseRent = data.tabs['pricing-tab'].tables['base-rent'].rows['occupied-space'].valueCells[2].getComputedValue(data.tabs, precomputedValues).internalValue;
        if (baseRent > 0) {
            propsData.base_rent = addCommasToNumber(baseRent);
        }
        const sqft = data.tabs['marketing-tab'].tables['offering-summary'].rows['gross-leasable-area'].getComputedValue(data.tabs, '', precomputedValues).internalValue;
        if (sqft > 0 && !propsData.sqft) {
            propsData.sqft = addCommasToNumber(sqft);
        }
        propsData.vacancy = data.tabs['current-rr-tab'].tables['sumed-detailed-information'].rows['first-row'].valueCells[0].getComputedValue(data.tabs, precomputedValues).internalValue;

        // set underwriting parcels cam just if the value has been changed
        const parcels = data.tabs['property-information-tab'].tables['parcel'].rows;
        const originalParcels = originalData.tabs['property-information-tab'].tables['parcel'].rows;
        const newParcelsData = [];
        const parcelCols = ['parcel', 'assessed_value', 'tax_liability'];

        for (let index = 0; index < 4; index++) {
            const parcelObj = {};
            parcels[`tax-assessment-${index+1}`].valueCells.map((tax, taxIndex) => {
                if (tax.value !== originalParcels[`tax-assessment-${index+1}`].valueCells[taxIndex].value) {
                    parcelObj[parcelCols[taxIndex]] = tax.value;
                }
            });

            // Set only if there was at least a change and the property exists
            if (Object.keys(parcelObj).length && propertyId) {
                parcelObj.property_id = propertyId;
                if (parcelsData[index] && parcelsData[index].arcimedes_row_id) {
                    parcelObj.arcimedes_row_id = parcelsData[index].arcimedes_row_id;
                }
                newParcelsData.push(parcelObj);
            }
        }

        // set underwriting expenses cam just if the value has been changed
        const cams = data.tabs['expenses-tab'].tables['expenses'].rows;
        const originalCam = originalData.tabs['expenses-tab'].tables['expenses'].rows;
        const newCamData = [];
        const camCols = ['cam_name', '', 'cam_value', '', '', 'proforma_cam_value', ''];
        const camRows = Object.entries(cams);
        const {camNo} = UnderwritingMultiTenant.findCamRowNO(camRows);
        const deletedRows = camData ? cloneDeep(camData) : [];
        const arcRowIdIndex = cams['cam-1'].valueCells.length - 1;

        for (let index = 0; index < camNo; index++) {
            const camObj = {};
            const camKey = `cam-${index+1}`;
            const rowId = cams[camKey].valueCells[arcRowIdIndex].value;

            // remove existing rows in order to have only the deleted ones
            if (rowId) {
                const index = findIndex(deletedRows, {arcimedes_row_id: rowId});
                if (index > -1)
                    deletedRows.splice(index, 1);
            }

            const lastIndex = cams[camKey].valueCells.length - 2;
            cams[camKey].valueCells.map((cam, camIndex) => {
                if (camIndex < lastIndex &&
                    (!originalCam[camKey] && cam.editable ||
                     originalCam[camKey] && cam.value !== originalCam[camKey].valueCells[camIndex].value)) {
                    camObj[camCols[camIndex]] = cam.value;
                }
            });

            // Set only if there was at least a change and the property exists
            if (Object.keys(camObj).length && propertyId) {
                camObj.property_id = Number(propertyId);
                camObj.cam_index = index + 1;
                if (rowId)
                    camObj.arcimedes_row_id = rowId;
                newCamData.push(camObj);
            }
        }

        deletedRows.map(row => {
            newCamData.push({
                arcimedes_row_id: row.arcimedes_row_id,
                deleted: 1,
            });
        });

        // set underwriting current rr & current reimbursement just if the value has been changed
        let newTenantsData = [];
        let savedTenants = false;
        const newTenants = [];
        let tenantData = null;
        let deletedTenants = tenantsData ? cloneDeep(tenantsData) : [];

        const currentRowOrder = Object.keys(data.tabs['current-rr-tab'].tables['general-information'].rows);
const originalRowOrder = Object.keys(originalData.tabs['current-rr-tab'].tables['general-information'].rows);
const isRowOrderChanged = JSON.stringify(currentRowOrder) !== JSON.stringify(originalRowOrder);

        await Promise.all(tenantFields.map(async prop => {
            const rows = prop.tab === "current-rr-tab" && prop.table === "general-information" ? data.tabs['current-rr-tab'].tables['general-information'].rows: data.tabs[prop.tab].tables[prop.table].rows;
            const originalRows = prop.tab === "current-rr-tab" && prop.table === "general-information" ? originalData.tabs['current-rr-tab'].tables['general-information'].rows: originalData.tabs[prop.tab].tables[prop.table].rows;
            const tenantRowIdIndex = rows[0].valueCells.length - 1; // TENANT_ROW_ID should always be the last column
            const arcRowIdIndex = tenantRowIdIndex - 1; // ARCIMEDES_ROW_ID should always be the last but one column

            await Promise.all(Object.keys(rows).map(async key => {
                if (prop.hasOwnProperty('valueCellIndex')) {
                    const arcRowId = rows[key].valueCells[arcRowIdIndex].value;
                    const tenantRowId = rows[key].valueCells[tenantRowIdIndex].value;
                    const value = rows[key].valueCells[prop.valueCellIndex].value;
                    const originalRow = findTenantRow(originalRows, arcRowIdIndex, arcRowId);
                    const originalValue = originalRow ? originalRow.valueCells[prop.valueCellIndex].value : '';

                    if (prop.key === 'arcimedes_row_id' && value) {
                        let tenantId = findIndex(deletedTenants, {arcimedes_row_id: value});
                        if (tenantId >= 0)
                            deletedTenants.splice(tenantId, 1);
                    }

                    // set only if there was a change
                    if (value !== originalValue || isRowOrderChanged && !['arcimedes_row_id', 'tenant_row_id'].includes(prop.key)) {
                        if (!newTenantsData[tenantRowId])
                            newTenantsData[tenantRowId] = {};

                        if (!newTenantsData[tenantRowId].property_id) {
                            newTenantsData[tenantRowId].property_id = propertyId ? propertyId.toString() : this.props.newPropertyId.toString();
                            newTenantsData[tenantRowId].deleted = null;
                            newTenantsData[tenantRowId].tenant_row_id = tenantRowId;
                            if (arcRowId){
                                newTenantsData[tenantRowId].arcimedes_row_id = arcRowId;
                            }
                        }

                        if (prop.key === 'tenant_name') {
                            tenantData = find(tenantsData, {arcimedes_row_id: arcRowId});
                            if (tenantData)
                                deletedTenants.push({tenant_id: tenantData.tenant_id});

                            // find tenant by name in existing tenants
                            const tenant = this.findTenant(value);
                            // if it doesn't exist, first save Tenant in TENANTS table
                            if (!tenant) {
                                const newTenant = await this.saveTenant(value);
                                newTenants.push({arcimedes_row_id: newTenant.arcimedes_row_id, name: value});
                                newTenantsData[tenantRowId].tenant_id = newTenant.arcimedes_row_id;
                                propsData.tenant_id = propsData.tenant_id ? `${propsData.tenant_id},${newTenant.arcimedes_row_id}` : newTenant.arcimedes_row_id;
                                savedTenants = true;
                            } else {
                                newTenantsData[tenantRowId].tenant_id = tenant.arcimedes_row_id;
                                propsData.tenant_id = propsData.tenant_id ? `${propsData.tenant_id},${tenant.arcimedes_row_id}` : tenant.arcimedes_row_id;
                                savedTenants = true;
                            }
                        }

                        switch (prop.type) {
                            case 'string': {
                                newTenantsData[tenantRowId][prop.key] = value;
                                break;
                            }
                            case 'number': {
                                newTenantsData[tenantRowId][prop.key] = value ? parseFloat(value) : null;
                                break;
                            }
                            case 'date': {
                                newTenantsData[tenantRowId][prop.key] = value ? stringUStoISO(value) : null;
                                break;
                            }
                        }
                    }
                }
            }));
        }));

        newTenantsData = newTenantsData.filter(el => el);
        deletedTenants = deletedTenants.map(el => {
            if (typeof propsData.tenant_id === "number") {
                propsData.tenant_id = propsData.tenant_id.toString();
            }
            if (propsData.tenant_id) {
                let ids = propsData.tenant_id.split(',');
                const index = ids.indexOf(el.tenant_id && el.tenant_id.toString());
                if (index === -1){
                    if (findIndex(newTenantsData, {arcimedes_row_id: el.arcimedes_row_id}) === -1) {
                        el.deleted = '1';
                        newTenantsData.push(el);
                        return el;
                    }
                };
                ids.splice(index, 1);
                ids = ids.join(',');
                // if TENANT_NAME was changed (new Tenant on existing row) delete it just from Property TENANT_ID
                if (el.tenant_id && !el.property_id) {
                    propsData.tenant_id = ids;
                    return el;
                }
                // if a tenant data (row) was deleted
                if (findIndex(newTenantsData, {arcimedes_row_id: el.arcimedes_row_id}) === -1) {
                    propsData.tenant_id = ids;
                    el.deleted = '1';
                    newTenantsData.push(el);
                    return el;
                }
            }
        });

        // set underwriting current & pro forma reimbursement types just if the value has been changed
        const tenantTypes = data.tabs['current-reimbursement-tab'].tables['reimbursement-types'].rows;
        const originalTenantTypes = originalData.tabs['current-reimbursement-tab'].tables['reimbursement-types'].rows;
        const tenantTypesProForma = data.tabs['proforma-reimbursement-tab'].tables['reimbursement-types'].rows;
        const originalTenantTypesProForma = originalData.tabs['proforma-reimbursement-tab'].tables['reimbursement-types'].rows;
        const newTenantTypesData = [];

        Object.keys(tenantTypes).map(key => {
            const tenantTypeObj = {};

            tenantTypeFields.map(prop => {
                let value = null;
                let originalValue = null;
                if (prop.key.includes('pro_forma')) {
                    value = tenantTypesProForma[key].valueCells[prop.valueCellIndex].value;
                    originalValue = originalTenantTypesProForma[key].valueCells[prop.valueCellIndex].value;
                } else {
                    value = tenantTypes[key].valueCells[prop.valueCellIndex].value;
                    originalValue = originalTenantTypes[key].valueCells[prop.valueCellIndex].value;
                }

                if (value !== originalValue) {
                    switch (prop.type) {
                        case 'string':
                            tenantTypeObj[prop.key] = value;
                            break;
                        case 'number':
                            tenantTypeObj[prop.key] = value && !isNaN(value) ? parseFloat(value) : null;
                            break;
                        case 'checkbox':
                            tenantTypeObj[prop.key] = value ? 1 : 0;
                            break;
                    }
                }
            });

            if (Object.keys(tenantTypeObj).length && propertyId) {
                if (!tenantTypeObj.property_id)
                    tenantTypeObj.property_id = propertyId && propertyId.toString();
                if (!tenantTypeObj.reimb_types_index)
                    tenantTypeObj.reimb_types_index = parseInt(key);
                if (tenantTypeData && tenantTypeData[key] && tenantTypeData[key].arcimedes_row_id)
                    tenantTypeObj.arcimedes_row_id = tenantTypeData[key].arcimedes_row_id;
                tenantTypeObj.reimb_types_cam_increase = tenantTypeObj.reimb_types_cam_increase && tenantTypeObj.reimb_types_cam_increase.toString();
                tenantTypeObj.pro_forma_reimb_types_cam_increase = tenantTypeObj.pro_forma_reimb_types_cam_increase && tenantTypeObj.pro_forma_reimb_types_cam_increase.toString();
                newTenantTypesData.push(tenantTypeObj);
            }
        });

        if (this.state.reimbTypesManuallyModified !== this.state.originalReimbTypesManuallyModified)
            underwritingData.reimb_types_manually_modified = this.state.reimbTypesManuallyModified ? 1 : 0;

        const id = propertyId ? propertyId : this.props.newPropertyId;
        if (Object.keys(underwritingData).length)
            underwritingData.property_id = id && id.toString();
        if (!propertyId)
            propsData.arcimedes_row_id = this.props.newPropertyId;

        const noChangesDetected = !Object.keys(underwritingData).length && newParcelsData.length < 1 && newCamData.length < 1 && newTenantsData.length < 1 && newTenantTypesData.length < 1 && !changesInPropData;
        const success = noChangesDetected ? 'No data to update' : '';

        // Sent back the property props
        this.setState({newData: propsData});
        this.props.parentSetData({newData: propsData, savedTenants: savedTenants, newTenants: newTenants, success});

        // No changes detected for Underwriting, nothing to do
        // if (noChangesDetected) return;
        newTenantsData.forEach(item => {
            if (typeof item.tenant_row_id === 'number') {
                item.tenant_row_id = item.tenant_row_id.toString();
            }
            if(typeof item.rr_monthly_rent === 'string'){
                item.rr_monthly_rent = parseInt(item.rr_monthly_rent, 10)
            }
            if(typeof item.rr_escalation_monthly_rent === 'string'){
                item.rr_escalation_monthly_rent = parseInt(item.rr_escalation_monthly_rent, 10)
            }
            if (typeof item.reimb_annual_other === 'number') {
                item.reimb_annual_other = item.reimb_annual_other.toString();
            }
            if (typeof item.reimb_annual_other_1 === 'number') {
                item.reimb_annual_other_1 = item.reimb_annual_other_1.toString();
            }

            if (typeof item.reimb_monthly_ret === 'number') {
                item.reimb_monthly_ret = item.reimb_monthly_ret.toString();
            }
            if (typeof item.reimb_monthly_ins === 'number') {
                item.reimb_monthly_ins = item.reimb_monthly_ins.toString();
            }
            if (typeof item.reimb_monthly_cam === 'number') {
                item.reimb_monthly_cam = item.reimb_monthly_cam.toString();
            }
            if (typeof item.reimb_monthly_other === 'number') {
                item.reimb_monthly_other = item.reimb_monthly_other.toString();
            }
            if (typeof item.proforma_reimb_code === 'number') {
                item.proforma_reimb_code = item.proforma_reimb_code.toString();
            }
            if(typeof item.proforma_ti_sf === 'string'){
                item.proforma_ti_sf = parseInt(item.proforma_ti_sf, 10)
            }
            if(typeof item.proforma_lc === 'string'){
                item.proforma_lc = parseInt(item.proforma_lc, 10)
            }
            if(typeof item.tenant_id === 'string'){
                item.tenant_id = parseInt(item.tenant_id, 10)
            }
        });
        underwritingData.current_non_reimb_expenses = underwritingData.current_non_reimb_expenses && underwritingData.current_non_reimb_expenses.toString();
        underwritingData.proforma_non_reimb_expenses = underwritingData.proforma_non_reimb_expenses && underwritingData.proforma_non_reimb_expenses.toString();
        underwritingData.proforma_vacancy_factor = underwritingData.proforma_vacancy_factor && underwritingData.proforma_vacancy_factor.toString();
        underwritingData.proforma_yield = underwritingData.proforma_yield && underwritingData.proforma_yield.toString();

        underwritingData.principal_balance = underwritingData.principal_balance && underwritingData.principal_balance.toString();
        underwritingData.proforma_principal_balance = underwritingData.proforma_principal_balance && underwritingData.proforma_principal_balance.toString();
        underwritingData.loan_amount = underwritingData.loan_amount && underwritingData.loan_amount.toString();
        underwritingData.proforma_loan_amount = underwritingData.proforma_loan_amount && underwritingData.proforma_loan_amount.toString();
        underwritingData.down_payment = underwritingData.down_payment && underwritingData.down_payment.toString();
        underwritingData.proforma_down_payment = underwritingData.proforma_down_payment && underwritingData.proforma_down_payment.toString();

        underwritingData.additional_price = underwritingData.additional_price && underwritingData.additional_price.toString();
        underwritingData.vacancy_factor = underwritingData.vacancy_factor && underwritingData.vacancy_factor.toString();
        underwritingData.current_real_estate_taxes = underwritingData.current_real_estate_taxes && underwritingData.current_real_estate_taxes.toString();
        underwritingData.current_insurance = underwritingData.current_insurance && underwritingData.current_insurance.toString();

        underwritingData.expenses_management_fee_of_gpi = underwritingData.expenses_management_fee_of_gpi && underwritingData.expenses_management_fee_of_gpi.toString();
        underwritingData.proforma_real_estate_taxes = underwritingData.proforma_real_estate_taxes && underwritingData.proforma_real_estate_taxes.toString();
        underwritingData.proforma_insurance = underwritingData.proforma_insurance && underwritingData.proforma_insurance.toString();
        underwritingData.proforma_mgmt_fee_of_gpi = underwritingData.proforma_mgmt_fee_of_gpi && underwritingData.proforma_mgmt_fee_of_gpi.toString();
        underwritingData.proforma_additional_price = underwritingData.proforma_additional_price && underwritingData.proforma_additional_price.toString();

        underwritingData.lot_size = underwritingData.lot_size && underwritingData.lot_size.toString();
        underwritingData.current_tax_appraised_value = underwritingData.current_tax_appraised_value && underwritingData.current_tax_appraised_value.toString();
        underwritingData.current_tax_liability = underwritingData.current_tax_liability && underwritingData.current_tax_liability.toString();
        underwritingData.down_payment_percent = underwritingData.down_payment_percent && underwritingData.down_payment_percent.toString();
        underwritingData.pricing_bps_increase = underwritingData.pricing_bps_increase && underwritingData.pricing_bps_increase.toString();
        underwritingData.pricing_bps_increase_pro = underwritingData.pricing_bps_increase_pro && underwritingData.pricing_bps_increase_pro.toString();
        underwritingData.proforma_down_payment_percent = underwritingData.proforma_down_payment_percent && underwritingData.proforma_down_payment_percent.toString();
        underwritingData.amortization = underwritingData.amortization && underwritingData.amortization.toString();
        underwritingData.proforma_amortization = underwritingData.proforma_amortization && underwritingData.proforma_amortization.toString();

        Promise.all([
            mutateData(UPDATE_UNDERWRITING_MULTI_TENANT,{ input: underwritingData }),
            mutateData(CREATE_UPDATE_UNDERWRITING_PARCELS,{ input: newParcelsData }),
            mutateData(UPDATE_UNDERWRITING_EXPENSES_CAMS,{ input: newCamData }),

            // mutateData(UNDERWRITING_TENANTS,{ input: newTenantsData }),
            // mutateData(UNDERWRITING_TENANTS, {
            //     input: newTenantsData.map(({ __typename,...item }) => ({
            //         ...item,
            //         proforma_rr_psf: item.proforma_rr_psf !=undefined && Math.round(item.proforma_rr_psf),
            //         tenant_row_id: item.tenant_row_id ? item.tenant_row_id.toString() : null,
            //         property_id: item.property_id ? item.property_id.toString() : null,
            //         deleted: item.deleted ? parseInt(item.deleted, 10) : null,
            //         rr_monthly_rent : item.rr_monthly_rent && item.rr_monthly_rent.toString(),
            //         proforma_lc : item.proforma_lc && item.proforma_lc.toString(),
            //         rr_escalation_monthly_rent : item.rr_escalation_monthly_rent && item.rr_escalation_monthly_rent.toString(),
            //         proforma_ti_sf : item.proforma_ti_sf && item.proforma_ti_sf.toString()

            //       }))
            //   }),
            mutateData(UNDERWRITING_TENANTS, {
                input: newTenantsData.map(({ __typename, ...item }) => {
                  const transformedItem = {
                    ...item,
                    tenant_row_id: item.tenant_row_id ? item.tenant_row_id.toString() : null,
                    property_id: item.property_id ? item.property_id.toString() : null,
                    deleted: item.deleted ? parseInt(item.deleted, 10) : null,
                    rr_monthly_rent: item.rr_monthly_rent && item.rr_monthly_rent.toString(),
                    proforma_lc: item.proforma_lc && item.proforma_lc.toString(),
                    rr_escalation_monthly_rent: item.rr_escalation_monthly_rent && item.rr_escalation_monthly_rent.toString(),
                    proforma_ti_sf: item.proforma_ti_sf && item.proforma_ti_sf.toString()
                  };
              
                  // Only add proforma_rr_psf if it exists
                  if (item.proforma_rr_psf) {
                    transformedItem.proforma_rr_psf = item.proforma_rr_psf.toString();
                  }
              
                  return transformedItem;
                })
              }),
            mutateData(UPDATE_UNDERWRITING_TENENT_TYPES,{"input": newTenantTypesData})
        ]).then(res => {
            if (!res || !res[0] || (!res[0].data.createOrUpdateUnderwritingMultiTenent.success && Object.keys(underwritingData).length) ||
                !res[1] || (!res[1].data.createOrUpdateUnderwritingParcel.success && newParcelsData.length) ||
                !res[2] || (!res[2].data.createOrUpdateUnderwritingExpensesCams.success && newCamData.length) ||
                !res[3] || (!res[3].data.createOrUpdateUnderwritingTenent.success && newTenantsData.length) ||
                !res[4] || (!res[4].data.createOrUpdateUnderwritingTenentType.success && newTenantTypesData.length)) {
                this.props.parentSetData({error: 'Unidentified Error'});
                return;
            }
            this.setState({isBusy: false});
            this.getUnderwritingData(true);
        });
    }

    handleExpand({tabId, tablesId, rowsId, cellsId}) {
        let data = cloneDeep(this.state.data);
        const tables = data.tabs[tabId].tables;

        tablesId.map(tableId => {
            const rows = tables[tableId].rows ? tables[tableId].rows : {};
            const rId = rowsId && rowsId[tableId] ? rowsId[tableId] : Object.keys(rows);
            rId.map(rowId => {
                const cId = cellsId ? cellsId : Object.keys(rows[rowId].valueCells);
                cId.map(cellId => {
                    rows[rowId].valueCells[cellId].hidden = !rows[rowId].valueCells[cellId].hidden;
                });
            });

            const footerRow = tables[tableId].footerRow ? tables[tableId].footerRow : {};
            if (Object.keys(footerRow).length && cellsId) {
                cellsId.map(cellId => {
                    footerRow.valueCells[cellId].hidden = !footerRow.valueCells[cellId].hidden;
                });
            }
        });

        this.setState({data});
    }

    handleExpandShow({tabId, tablesId, rowsId, cellsId,toggleState}) {
        let data = cloneDeep(this.state.data);
        const tables = data.tabs[tabId].tables;

        tablesId.map(tableId => {
            const rows = tables[tableId].rows ? tables[tableId].rows : {};
            const rId = rowsId && rowsId[tableId] ? rowsId[tableId] : Object.keys(rows);
            rId.map(rowId => {
                const cId = cellsId ? cellsId : Object.keys(rows[rowId].valueCells);
                cId.map(cellId => {
                    rows[rowId].valueCells[cellId].hidden = toggleState;
                });
            });

            const footerRow = tables[tableId].footerRow ? tables[tableId].footerRow : {};
            if (Object.keys(footerRow).length && cellsId) {
                cellsId.map(cellId => {
                    footerRow.valueCells[cellId].hidden = toggleState;
                });
            }
        });

        this.setState({data});
    }

    sortTenants(key, sort, sortState) {
        let data = cloneDeep(this.state.data);
        this.getTenants(data, key, sort, sortState);
    }

    async getStaticImages(type){
        const res = await fetchData(GET_PRICING_ANALYSIS_BY_PRODUCT_TYPE, { productType: type });
        if (res && res.data && res.data.getPricingAnalysisByProductType) { this.setState({ staticImages: preProcess(res.data.getPricingAnalysisByProductType.items) }); return preProcess(res.data.getPricingAnalysisByProductType.items); }
    }

    onConfirm(){
        this.setState({isDialogueOpen: false});
        this.onSubmit()
    }
    onCancel(){
        this.setState({isDialogueOpen: false, isBusy: false});
    }
    reindexCamIndex(arr) {
        return arr.map((item, idx) => ({
            ...item,
            cam_index: idx + 1
        }));
    }
    async beforeSubmit(){

        if(this.state.isBusy)return;
        this.setState({isBusy: true});
        
        if(!(["Active", "In Negotiation", "Under Contract"].includes(this.props.data.status) && this.props.data.source === "STRIVE")){
            this.onSubmit();
            return;
        }
        
        const {parcelsData, camData, tenantsData, tenantTypeData} = this.state;
        let data = this.state.data;
        const originalData = this.state.original;
        const propsData = cloneDeep(this.props.data);
        const propertyId = this.props.data.arcimedes_row_id;
        const underwritingData = {};
        let changesInPropData = false;

        const precomputedValues = BaseTabComponent.precomputeHeavilyUsedValues(this.state.data.tabs);
        // Compute Reimbursement Types values
        ['current-reimbursement-tab', 'proforma-reimbursement-tab'].forEach(tab => {
            const state = computeReimbTypes({
                result: data.tabs,
                tab: tab,
                precomputedValues,
                newSqft: this.state.sqFtUpdated,
                newCam: this.state.camPSFSumUpdated,
                newMgmt: this.state.mgmtUpdated,
                newInsurance: this.state.insuranceUpdated,
                newTaxes: this.state.taxesUpdated,
                reimbTypesManuallyModified: this.state.reimbTypesManuallyModified,
            });
            data = state.data;
        });
        stringProps.map(prop => {
            let value, originalValue;
            if (prop.hasOwnProperty('valueCellIndex')) {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
            } else {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
            }

            if (prop.fromProps) {
                // set property props
                if (value !== originalValue) {
                    propsData[prop.key] = value;
                    changesInPropData = true;
                }
            } else {
                // set underwritingData just if the value has been changed
                if (value !== originalValue) {
                    underwritingData[prop.key] = value;
                }
            }
        });

        dateProps.map(prop => {
            let value, originalValue;
            if (prop.hasOwnProperty('valueCellIndex')) {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
            } else {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
            }

            if (prop.fromProps) {
                // set property props
                if (value !== originalValue) {
                    propsData[prop.key] = value;
                    changesInPropData = true;
                }
            } else {
                // set underwritingData just if the value has been changed
                if (value !== originalValue) {
                    underwritingData[prop.key] = value ? stringUStoISO(value) : '';
                }
            }
        });

        numberProps.map(prop => {
            let value, originalValue;
            if (prop.hasOwnProperty('valueCellIndex')) {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
            } else {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
            }

            if (prop.fromProps) {
                // set property props
                if (prop.withReplace) {
                    if (value !== originalValue) {
                        propsData[prop.key] = addCommasToNumber(value);
                        changesInPropData = true;
                    }
                    return;
                }
                if (value !== originalValue) {
                    propsData[prop.key] = value.toString();
                    changesInPropData = true;
                }
            } else {
                if (value !== originalValue) {
                    underwritingData[prop.key] = parseFloat(value);
                }
            }
        });

        checkboxProps.map(prop => {
            let value, originalValue;
            if (prop.hasOwnProperty('valueCellIndex')) {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
            } else {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
            }

            // set underwritingData just if the value has been changed
            if (value !== originalValue)
                underwritingData[prop.key] = value ? 1 : 0;

        });

        const noi = data.tabs['pricing-tab'].tables['net-operating-income'].rows['net-operating-income'].valueCells[2].getComputedValue(data.tabs, precomputedValues).internalValue;
        const proformaNoi = data.tabs['pricing-tab'].tables['net-operating-income'].rows['net-operating-income'].valueCells[6].getComputedValue(data.tabs, precomputedValues).internalValue;
        const proformaCapRate = data.tabs['pricing-tab'].tables['value'].rows['cap-rate'].valueCells[6].value;
        const proformaBaseRent = data.tabs['pricing-tab'].tables['base-rent'].footerRow.valueCells[6].getComputedValue(data.tabs, precomputedValues).internalValue;
        

        if (noi > 0) {
            propsData.net_operating_income = addCommasToNumber(noi);
        }
        // Proforma property financials changes
        if (proformaNoi > 0) {
            propsData.proforma_noi = proformaNoi;
        }
        if(proformaBaseRent > 0){
            propsData.proforma_base_rent = proformaBaseRent;
        }
        if(proformaCapRate > 0){
            propsData.proforma_cap_rate = proformaCapRate;
        }


        const listPrice = data.tabs['pricing-tab'].tables['value'].rows['value'].valueCells[2].getComputedValue(data.tabs, precomputedValues).internalValue;
        if (listPrice > 0) {
            propsData.list_price = addCommasToNumber(listPrice);
        }
        const baseRent = data.tabs['pricing-tab'].tables['base-rent'].rows['occupied-space'].valueCells[2].getComputedValue(data.tabs, precomputedValues).internalValue;
        if (baseRent > 0) {
            propsData.base_rent = addCommasToNumber(baseRent);
        }
        const sqft = data.tabs['marketing-tab'].tables['offering-summary'].rows['gross-leasable-area'].getComputedValue(data.tabs, '', precomputedValues).internalValue;
        if (sqft > 0 && !propsData.SQFT) {
            propsData.sqft = addCommasToNumber(sqft);
        }
        propsData.vacancy = data.tabs['current-rr-tab'].tables['sumed-detailed-information'].rows['first-row'].valueCells[0].getComputedValue(data.tabs, precomputedValues).internalValue;

        // set underwriting parcels cam just if the value has been changed
        const parcels = data.tabs['property-information-tab'].tables['parcel'].rows;
        const originalParcels = originalData.tabs['property-information-tab'].tables['parcel'].rows;
        const newParcelsData = [];
        const parcelCols = ['PARCEL', 'ASSESSED_VALUE', 'TAX_LIABILITY'];

        for (let index = 0; index < 4; index++) {
            const parcelObj = {};
            parcels[`tax-assessment-${index+1}`].valueCells.map((tax, taxIndex) => {
                if (tax.value !== originalParcels[`tax-assessment-${index+1}`].valueCells[taxIndex].value) {
                    parcelObj[parcelCols[taxIndex]] = tax.value;
                }
            });

            // Set only if there was at least a change and the property exists
            if (Object.keys(parcelObj).length && propertyId) {
                parcelObj.PROPERTY_ID = propertyId;
                if (parcelsData && parcelsData[index] && parcelsData[index].arcimedes_row_id) {
                    parcelObj.arcimedes_row_id = parcelsData[index].arcimedes_row_id;
                }
                newParcelsData.push(parcelObj);
            }
        }

        // set underwriting expenses cam just if the value has been changed
        const cams = data.tabs['expenses-tab'].tables['expenses'].rows;
        const originalCam = originalData.tabs['expenses-tab'].tables['expenses'].rows;
        const newCamData = [];
        const camCols = ['cam_name', '', 'cam_value', '', '', 'proforma_cam_value', ''];
        const camRows = Object.entries(cams);
        const {camNo} = UnderwritingMultiTenant.findCamRowNO(camRows);
        const deletedRows = camData ? cloneDeep(camData) : [];
        const arcRowIdIndex = cams['cam-1'].valueCells.length - 1;

        for (let index = 0; index < camNo; index++) {
            const camObj = {};
            const camKey = `cam-${index+1}`;
            const rowId = cams[camKey].valueCells[arcRowIdIndex].value;

            // remove existing rows in order to have only the deleted ones
            if (rowId) {
                const index = findIndex(deletedRows, {arcimedes_row_id: rowId});
                if (index > -1)
                    deletedRows.splice(index, 1);
            }

            const lastIndex = cams[camKey].valueCells.length - 2;
            cams[camKey].valueCells.map((cam, camIndex) => {
                if (camIndex < lastIndex &&
                    (!originalCam[camKey] && cam.editable ||
                     originalCam[camKey] && cam.value !== originalCam[camKey].valueCells[camIndex].value)) {
                    camObj[camCols[camIndex]] = cam.value;
                }
            });

            // Set only if there was at least a change and the property exists
            if (Object.keys(camObj).length && propertyId) {
                camObj.property_id = parseInt(propertyId);
                camObj.cam_index = index + 1;
                if (rowId)
                    camObj.arcimedes_row_id = rowId;
                newCamData.push(camObj);
            }
        }

        deletedRows.map(row => {
            newCamData.push({
                arcimedes_row_id: row.arcimedes_row_id,
                deleted: 1,
            });
        });

        // set underwriting current rr & current reimbursement just if the value has been changed
        let newTenantsData = [];
        let savedTenants = false;
        const newTenants = [];
        let tenantData = null;
        let deletedTenants = tenantsData ? cloneDeep(tenantsData) : [];

        await Promise.all(tenantFields.map(async prop => {
            const rows = data.tabs[prop.tab].tables[prop.table].rows;
            const originalRows = originalData.tabs[prop.tab].tables[prop.table].rows;
            const tenantRowIdIndex = rows[0].valueCells.length - 1; // TENANT_ROW_ID should always be the last column
            const arcRowIdIndex = tenantRowIdIndex - 1; // ARCIMEDES_ROW_ID should always be the last but one column

            await Promise.all(Object.keys(rows).map(async key => {
                if (prop.hasOwnProperty('valueCellIndex')) {
                    const arcRowId = rows[key].valueCells[arcRowIdIndex].value;
                    const tenantRowId = rows[key].valueCells[tenantRowIdIndex].value;
                    const value = rows[key].valueCells[prop.valueCellIndex].value;
                    const originalRow = findTenantRow(originalRows, arcRowIdIndex, arcRowId);
                    const originalValue = originalRow ? originalRow.valueCells[prop.valueCellIndex].value : '';

                    if (prop.key === 'arcimedes_row_id' && value) {
                        let tenantId = findIndex(deletedTenants, {arcimedes_row_id: value});
                        if (tenantId >= 0)
                            deletedTenants.splice(tenantId, 1);
                    }

                    // set only if there was a change
                    if (value !== originalValue && !['arcimedes_row_id', 'tenant_row_id'].includes(prop.key)) {
                        if (!newTenantsData[tenantRowId])
                            newTenantsData[tenantRowId] = {};

                        if (!newTenantsData[tenantRowId].property_id) {
                            newTenantsData[tenantRowId].property_id = propertyId ? propertyId : this.props.newPropertyId;
                            newTenantsData[tenantRowId].DELETED = null;
                            newTenantsData[tenantRowId].tenant_row_id = tenantRowId;
                            if (arcRowId)
                                newTenantsData[tenantRowId].arcimedes_row_id = arcRowId;
                        }

                        if (prop.key === 'TENANT_NAME') {
                            tenantData = find(tenantsData, {arcimedes_row_id: arcRowId});
                            if (tenantData)
                                deletedTenants.push({tenant_id: tenantData.tenant_id});

                            // find tenant by name in existing tenants
                            const tenant = this.findTenant(value);
                            // if it doesn't exist, first save Tenant in TENANTS table
                            if (!tenant) {
                                const newTenant = await this.saveTenant(value);
                                newTenants.push({arcimedes_row_id: newTenant.arcimedes_row_id && newTenant.arcimedes_row_id, NAME: value});
                                newTenantsData[tenantRowId].tenant_id = newTenant.arcimedes_row_id;
                                propsData.tenant_id = propsData.tenant_id ? `${propsData.tenant_id},${newTenant.arcimedes_row_id}` : newTenant.arcimedes_row_id;
                                savedTenants = true;
                            } else {
                                newTenantsData[tenantRowId].tenant_id = tenant.arcimedes_row_id;
                                propsData.tenant_id = propsData.tenant_id ? `${propsData.tenant_id},${tenant.arcimedes_row_id}` : tenant.arcimedes_row_id;
                                savedTenants = true;
                            }
                        }

                        switch (prop.type) {
                            case 'string': {
                                newTenantsData[tenantRowId][prop.key] = value;
                                break;
                            }
                            case 'number': {
                                newTenantsData[tenantRowId][prop.key] = value ? parseFloat(value) : null;
                                break;
                            }
                            case 'date': {
                                newTenantsData[tenantRowId][prop.key] = value ? stringUStoISO(value) : null;
                                break;
                            }
                        }
                    }
                }
            }));
        }));

        newTenantsData = newTenantsData.filter(el => el);
        deletedTenants = deletedTenants.map(el => {
            if (propsData.tenant_id) {
                let ids = propsData.tenant_id.split(',');
                const index = ids.indexOf(el.tenant_id);
                if (index === -1){
                    if (findIndex(newTenantsData, {arcimedes_row_id: el.arcimedes_row_id}) === -1) {
                        el.deleted = '1';
                        newTenantsData.push(el);
                        return el;
                    }
                };
                ids.splice(index, 1);
                ids = ids.join(',');
                // if TENANT_NAME was changed (new Tenant on existing row) delete it just from Property TENANT_ID
                if (el.tenant_id && !el.property_id) {
                    propsData.tenant_id = ids;
                    return el;
                }
                // if a tenant data (row) was deleted
                if (findIndex(newTenantsData, {arcimedes_row_id: el.arcimedes_row_id}) === -1) {
                    propsData.tenant_id = ids;
                    el.deleted = '1';
                    newTenantsData.push(el);
                    return el;
                }
            }
        });

        // set underwriting current & pro forma reimbursement types just if the value has been changed
        const tenantTypes = data.tabs['current-reimbursement-tab'].tables['reimbursement-types'].rows;
        const originalTenantTypes = originalData.tabs['current-reimbursement-tab'].tables['reimbursement-types'].rows;
        const tenantTypesProForma = data.tabs['proforma-reimbursement-tab'].tables['reimbursement-types'].rows;
        const originalTenantTypesProForma = originalData.tabs['proforma-reimbursement-tab'].tables['reimbursement-types'].rows;
        const newTenantTypesData = [];

        Object.keys(tenantTypes).map(key => {
            const tenantTypeObj = {};

            tenantTypeFields.map(prop => {
                let value = null;
                let originalValue = null;
                if (prop.key.includes('PRO_FORMA')) {
                    value = tenantTypesProForma[key].valueCells[prop.valueCellIndex].value;
                    originalValue = originalTenantTypesProForma[key].valueCells[prop.valueCellIndex].value;
                } else {
                    value = tenantTypes[key].valueCells[prop.valueCellIndex].value;
                    originalValue = originalTenantTypes[key].valueCells[prop.valueCellIndex].value;
                }

                if (value !== originalValue) {
                    switch (prop.type) {
                        case 'string':
                            tenantTypeObj[prop.key] = value;
                            break;
                        case 'number':
                            tenantTypeObj[prop.key] = value && !isNaN(value) ? parseFloat(value) : null;
                            break;
                        case 'checkbox':
                            tenantTypeObj[prop.key] = value ? 1 : 0;
                            break;
                    }
                }
            });

            if (Object.keys(tenantTypeObj).length && propertyId) {
                if (!tenantTypeObj.property_id)
                    tenantTypeObj.property_id = propertyId;
                if (!tenantTypeObj.reimb_types_index)
                    tenantTypeObj.reimb_types_index = parseInt(key);
                if (tenantTypeData && tenantTypeData[key] && tenantTypeData[key].arcimedes_row_id)
                    tenantTypeObj.arcimedes_row_id = tenantTypeData[key].arcimedes_row_id;
                newTenantTypesData.push(tenantTypeObj);
            }
        });

        if (this.state.reimbTypesManuallyModified !== this.state.originalReimbTypesManuallyModified)
            underwritingData.reimb_types_manually_modified = this.state.reimbTypesManuallyModified ? 1 : 0;

        const id = propertyId ? propertyId : this.props.newPropertyId;
        if (Object.keys(underwritingData).length)
            underwritingData.property_id = id;
        if (!propertyId)
            propsData.arcimedes_row_id = this.props.newPropertyId;

        const noChangesDetected = !Object.keys(underwritingData).length && newParcelsData.length < 1 && newCamData.length < 1 && newTenantsData.length < 1 && newTenantTypesData.length < 1 && !changesInPropData;
        const success = noChangesDetected ? 'No data to update' : '';


        // No changes detected for Underwriting, nothing to do
        if (noChangesDetected) {
            this.setState({isBusy: false});
            this.props.parentSetData({success})
            // return;
        };

        const originalDataPrecomputedValues = BaseTabComponent.precomputeHeavilyUsedValues(this.state.original.tabs);

        if(this.state.data.tabs['marketing-tab'].tables['offering-summary'].rows['price'].getComputedValue(this.state.data.tabs, '', precomputedValues).internalValue !== this.state.original.tabs['marketing-tab'].tables['offering-summary'].rows['price'].getComputedValue(this.state.original.tabs, '', originalDataPrecomputedValues).internalValue){
            this.setState({isDialogueOpen: true, dialogTitle:'Do you have an Amendment to the Rep Agreement to change the price?'});
        }else{
            this.setState({isDialogueOpen: true, dialogTitle:'Are you sure you want to save this financial data?'});
        }
    }

    render() {
        const {data, selectedTab, sqFtUpdated, camPSFSumUpdated, mgmtUpdated, insuranceUpdated, taxesUpdated, dataLoaded, movedRows, reimbTypesManuallyModified, staticImages} = this.state;
        const propertyImage = this.props.data.website_photo_1 ? this.props.data.website_photo_1 : '';
        const agents = this.props.agents;
         const storedUserData = JSON.parse(sessionStorage.getItem("userData") || "{}");
         const isSeniorAgentDisable = isSeniorAgent(storedUserData)  && this.props.data.source == "External" || ( this.props.data.source == "STRIVE" && ['Proposal', 'Property Info',].includes(this.props.data.status));
        
        const disabled = !isSeniorAgentDisable && !(this.props.isSuper || this.props.agentIsCurrentUser && ['Proposal', 'Property Info', 'Off Market', 'Removed'].includes(this.props.data.status));
        const propertyMapProps = {
            latitude: this.props.data.latitude ? parseFloat(this.props.data.latitude) : 0,
            longitude: this.props.data.longitude ? parseFloat(this.props.data.longitude) : 0,
            name: this.props.data.name
        };
        const isCategoryOffice = this.props.data.category == "office";
        const isIndustrial = this.props.data.category == "industrial";

        // Combinations that have an approved new-template build render through PrintBOV;
        // everything else keeps the existing deck.
        const bovTemplate = getTemplate(
            bovOfficeFor({zip: this.props.data.zip, market: this.props.data.market}),
            this.props.data.category,
            'Multi Tenant'
        );
        return (
            <ApolloConsumer>
            {
                client => {
                    if (!this.client) {
                        this.client = client;
                    }
                    return (
            <div>
            <PopupDialog
                    title={this.state.dialogTitle} 
                    isOpen={this.state.isDialogueOpen} 
                    onConfirm={() => { this.onConfirm()}}
                    onCancel={() => {this.onCancel()}}
                />
                {bovTemplate
                    ? <PrintBOV template={bovTemplate} proposalData={this.props.proposalData} tabs={data.tabs} propertyMapProps={propertyMapProps} agents={agents} propertyRecord={this.props.data} propertyImages={[1, 2, 3, 4, 5].map(n => this.props.data[`website_photo_${n}`])}/>
                    : <PrintMultiTenant staticImages={staticImages||defualtStaticImages} isCategoryOffice={isCategoryOffice} isIndustrial={isIndustrial} location={this.props.location} proposalData = {this.props.proposalData} tabs={data.tabs} propertyImage={propertyImage} propertyMapProps={propertyMapProps} agents={agents}/>
                }
                <div className="Financials_content multi_tenant_content">
                    {/* <div onMouseEnter={this.togglePopupMessage} onMouseLeave={this.togglePopupMessage} className='placeholder-button'/> */}
                    {/* <button className={`Financials_submit_button${disabled ? '_disabled' : ''}`} onClick={movedRows ? this.reassignTenantRowIds : this.onSubmit} disabled={disabled}>Submit</button> */}
                    <button className={`Financials_submit_button${disabled ? '_disabled' : ''}`} onClick={(e)=>{e.preventDefault(); movedRows ? this.reassignTenantRowIds() : this.beforeSubmit()}} disabled={disabled}>Submit</button>
                    {disabled && this.state.displayPopupSubmit ? <div className='Financials_submit_message'>Don't have permission to save.</div> : null}
                    <div className="multi_tenant_tabs">
                        {Object.keys(data.tabs).map((tabKey) => {
                            const tab = data.tabs[tabKey];
                            return (
                                <div className={`tab ${selectedTab}${selectedTab === tabKey ? ' selected' : ''}${dataLoaded ? '' : ' disabled'}`} key={tabKey} onClick={() => {this.changeTab(tabKey)}}>
                                    {tab.name}
                                </div>
                            )
                        })}
                    </div>
                    <div className="content">
                        {selectedTab === 'marketing-tab' ?
                            <Marketing tabs={data.tabs} valueChange={this.tabValueChange} setState={this.setState} handleExpand={this.handleExpand}
                                       isMarketingAdditionalPriceVisible={this.state.isMarketingAdditionalPriceVisible} handleExpandShow={this.handleExpandShow}/>
                            : selectedTab === 'property-information-tab' ?
                                <PropertyInformation tabs={data.tabs} valueChange={this.tabValueChange}/>
                                : selectedTab === 'pricing-tab' ?
                                    <Pricing tabs={data.tabs} valueChange={this.tabValueChange} valuesChange={this.tabValuesChange} handleExpand={this.handleExpand}
                                             setState={this.setState} isProformaVisiblePricing={this.state.isProformaVisiblePricing} isAdditionalPriceVisible={this.state.isAdditionalPriceVisible}/>
                                    : selectedTab === 'current-rr-tab' ?
                                        <CurrentRR tabs={data.tabs} tab='current-rr-tab' valueChange={this.tabValueChange} valuesChange={this.tabValuesChange}
                                                   addRow={this.addRow} deleteRow={this.deleteRowCurrentRR} moveRow={this.moveRow} moveCorrespondingRows={this.moveCorrespondingRows}
                                                   sortState={this.state.sortState} sortTenants={this.sortTenants}/>
                                        : selectedTab === 'current-reimbursement-tab' ?
                                            <CurrentReimbursement key={`current-reimbursement-tab-${selectedTab}-${this.state.dataReloadCounter}`} tabs={data.tabs} tab='current-reimbursement-tab' reimbTypesManuallyModified={reimbTypesManuallyModified}
                                                                  setState={this.setState} valueChange={this.tabValueChange} valuesChange={this.tabValuesChange}
                                                                  dataReloadCounter={this.state.dataReloadCounter}
                                                                  sqFtUpdated={sqFtUpdated} camPSFSumUpdated={camPSFSumUpdated} mgmtUpdated={mgmtUpdated} insuranceUpdated={insuranceUpdated} taxesUpdated={taxesUpdated}/>
                                            : selectedTab === 'expenses-tab' ?
                                                <Expenses tabs={data.tabs} valueChange={this.tabValueChange} valuesChange={this.tabValuesChange}
                                                          addRow={this.addRow} deleteRow={this.deleteRowCAM}
                                                          handleExpand={this.handleExpand} setState={this.setState}
                                                          isProformaVisible={this.state.isProformaVisible}/>
                                                : selectedTab === 'proforma-rr-tab' ?
                                                    <CurrentRR tabs={data.tabs} tab='proforma-rr-tab' valueChange={this.tabValueChange} valuesChange={this.tabValuesChange}
                                                               addRow={this.addRow} deleteRow={this.deleteRowCurrentRR}/>
                                                    : selectedTab === 'proforma-reimbursement-tab' ?
                                                        <CurrentReimbursement key={`proforma-reimbursement-tab-${selectedTab}-${this.state.dataReloadCounter}`} 
                                                                              tabs={data.tabs} 
                                                                              tab='proforma-reimbursement-tab' 
                                                                              reimbTypesManuallyModified={reimbTypesManuallyModified}
                                                                              setState={this.setState} 
                                                                              valueChange={this.tabValueChange} 
                                                                              valuesChange={this.tabValuesChange}
                                                                              dataReloadCounter={this.state.dataReloadCounter}
                                                                              camPSFSumUpdated={camPSFSumUpdated} 
                                                                              mgmtUpdated={mgmtUpdated} 
                                                                              insuranceUpdated={insuranceUpdated} 
                                                                              taxesUpdated={taxesUpdated}/>
                                                        : null
                        }
                    </div>
                </div>
            </div>
            )
        }
        }
        </ApolloConsumer>
        )
    }
}